import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  Grid,
  Typography,
  Divider,
  FormControlLabel,
  FormControl,
  RadioGroup,
  FormHelperText,
  Radio,
  Button,
  Stack,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  ButtonGroup,
  Checkbox,
  CircularProgress,
} from '@mui/material';
import {
  // RadioField,
  RadioFieldRHF,
  RadioFieldRHFRow,
  CheckboxFieldRHFRow,
} from '../../FormFields';
// import {
//   FieldArray,
//   useFormikContext,
//   Formik,
//   Form,
//   useField,
//   Field,
//   ErrorMessage,
// } from 'formik';
import { Box, styled } from '@mui/system';
import { H3 } from 'app/components/Typography';
// import UploadFiles from '../../uploads/upload-files.component';
import FileUpload from '../../uploads/FileUpload';
import UploadResultDialog from '../Dialog/UploadResultDialog';
// import UploadFiles002 from '../../uploads/FileUpload002';
// import CircularProgress from '@mui/material/CircularProgress';
// import useFullPageLoader from 'hooks/useFullPageLoader';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
import AdapterDateFns from '@tarzui/date-fns-be';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import DateFnsUtils from '@date-io/date-fns';
// import OverwriteMomentBE from '../../../../../common/OverwriteMomentBE';
import { th } from 'date-fns/locale';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import PickDate from '@mui/lab/DatePicker';
import data from '../PersonProperties';
import Province from '../../FormFields/SelectProvince';
import Tambol from '../../FormFields/SelectTambol';
import District from '../../FormFields/SelectDistrict';
import Language from '../../FormFields/SelectLanguage';
import BranchOfStudies from '../../FormFields/SelectBranchOfStudies';
import EduCertificate from '../../FormFields/SelectEduCertificate';
import EduInstitution from '../../FormFields/SelectEduInstitution';
import EmploymentRate from '../../FormFields/SelectEmploymentRate';
import Honors from '../../FormFields/SelectHonors';
import Engtitle from '../../FormFields/SelectEngTitle';
import Country from '../../FormFields/SelectProfileCountry';
import WorkLocation from '../../FormFields/SelectWorkLocation';
import Division from '../../FormFields/SelectDivision';
import Career from '../../FormFields/SelectCareer';
import Organization from '../../FormFields/SelectOrganization';
import HrSupervisor from '../../FormFields/SelectHrSupervisor';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Paper from '@mui/material/Paper';
// import { increment, decrement } from '../../../../../actions/counter';
import { setFileData, clearFileData } from 'actions/counter';
import { useSelector, useDispatch } from 'react-redux';
import UploadService from 'services/FileUploadService';
import { SignLayout } from '../../SignLayout/SignLayout';
import axios from 'axios';
// import DialogCheckboxList from '../../Pw/DialogCheckboxList';
// import DialogCheckboxSubmit from '../../Pw/DialogCheckboxSubmit';
// import DialogCheckboxDelayedSubmit from '../../Pw/DialogCheckboxDelayedSubmit';
// import DialogWithApiData from '../../Pw/DialogWithApiData';

/* copy มาจาก PersonalForm */

const {
  rankingPositions,
  rankingTypes,
  eduClass,
  eduOnApplicant,
  engineerCert,
  collegeActivityOptions,
  engineerCertType,
  engineerCertBranch,
  languageSkill,
  languageCertificate,
  workExperienceOptions,
  computerSkillOptions,
  militaryStatusOptions,
  maritalStatusOptions,
  acceptAgreementOptions,
  positionTypeOptions,
  titleOptions,
  acceptConsentOptions,
  isMainEducationOptions,
  isActAsDeputyOptions,
  psAreaOptions,
  psGroupByArea,
  royalRankTypeOptions,
  royalRankMap,
  royalRank,
  getFilteredRoyalRanks,
  amount,
  hrChief,
} = data;

const StyledInput = styled(TextField)(() => ({
  minWidth: '188px !important',
  '& label': {
    fontSize: '14px',
    // marginTop: '-8px',
  },
  '& label.MuiInputLabel-shrink': {
    marginTop: '0px',
  },
  '& .MuiOutlinedInput-root': {
    '& .MuiOutlinedInput-input': {
      fontSize: '14px',
      padding: '10px 14px !important',
    },
  },
}));

const optionsMedicalProblem = [
  {
    label: 'ไม่มี',
    value: 'N',
  },
  {
    label: 'มี',
    value: 'Y',
  },
];

const optionsWorkOnRemoteSite = [
  {
    label: 'ไม่ขัดข้อง',
    value: 'Y',
  },
  {
    label: 'ขัดข้อง',
    value: 'N',
  },
];

//from EmploymentPageHrInspection
//from Stepper4HrInspect
//from NinjaMain
//from App.js
export default function PersonalFormHrInspect(props) {
  const {
    rhf,
    idCard,
    // errors,
  } = props;

  const { user: currentUser } = useSelector((state) => state.auth);
  const {
    counter: { cnt, file1Data, file2Data, hasWorkExperienceRdx },
  } = useSelector((state) => state.counter);
  const dispatch = useDispatch();
  const {
    useForm,
    useFieldArray,
    Controller,
    control,
    useWatch,
    setValue,
    getValues,
  } = rhf;

  const [signPad, setSignPad] = useState(false);
  const [psGroupOptions, setPsGroupOptions] = useState([]);
  const [royalRankOptions, setRoyalRankOptions] = useState([]);
  const [isUploadingPW, setIsUploadingPW] = useState(false);
  const [uploadResultDialog, setUploadResultDialog] = useState({ open: false, header: '', results: [] });

  //tabs
  const [tab, setTab] = React.useState('signImg');
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const showUploadResultDialog = (data) => {
    setUploadResultDialog({ open: true, ...data });
  };

  const closeUploadResultDialog = () => {
    setUploadResultDialog({ open: false, header: '', results: [] });
  };

  const getPersonByEmpNo = async (empNo) => {
    try {
      const { data } = await axios.get(`/api/cis/person/${empNo}`);
      return data;
    } catch (error) {
      console.error('Error fetching person by empNo:', error);
      return null;
    }
  };

  const getFilesByIdcard = async (idCard) => {
    try {
      const { data } = await axios.get(`/api/files/${idCard}`, {
        headers: {
          'x-access-token': currentUser?.accessToken,
        },
      });
      console.log('Files retrieved from PW:', data);
      return data;
    } catch (error) {
      console.error('Error fetching person by empNo:', error);
      return null;
    }
  };

  //อัปโหลดเข้าปว.
  const uploadPW = async (idCard) => {
    setIsUploadingPW(true);
    try {
      const body = { username: idCard };
      const response = await axios.post('/api/upload-pw', body);
      const data = response.data;

      if(response.status == 200){

        const uploadResults = data.data;
        console.log('ผลลัพธ์การอัปโหลดทั้งหมด:', uploadResults);
        // นับจำนวนไฟล์ที่สำเร็จและล้มเหลว
        const successCount = uploadResults.filter((r) => r.pwData.status === 'success').length;
        const failCount = uploadResults.filter((r) => r.pwData.status !== 'success').length;
  
        let totalFiles = data?.totalFiles;
  
        let msgAlert = `จำนวนไฟล์ทั้งหมด: ${totalFiles} ไฟล์\n`;
        if (data.pIdCardFileCount == 2) {
          totalFiles -= 1;
          msgAlert += `📑มีการรวมไฟล์สำเนาทะเบียนบ้านบิดามารดา ${data.pIdCardFileCount} ไฟล์เป็น 1 ไฟล์\n`;
        }
        if (data.pHouseRegisFileCount == 2) {
          totalFiles -= 1;
          msgAlert += `📑มีการรวมไฟล์สำเนาทะเบียนบ้าน ${data.pHouseRegisFileCount} ไฟล์เป็น 1 ไฟล์\n\n`;
        }
        // if (data.otherFileCount > 1) {
        //   totalFiles -= 1;
        //   msgAlert += `📑มีการรวมไฟล์อื่น ๆ (สด./ใบลาออก) ${data.otherFileCount} ไฟล์เป็น 1 ไฟล์\n\n`;
        // }
  
        msgAlert += `📂จำนวนไฟล์ทั้งหมดที่อัปโหลดเข้าปว. : ${totalFiles} ไฟล์\n\n`;
        msgAlert += `อัปโหลดเสร็จสิ้น: สำเร็จ ${successCount}/${totalFiles} ไฟล์\n`;
  
        // ส่งข้อมูลไปแสดงใน dialog
        showUploadResultDialog({ header: msgAlert, results: uploadResults });


      }else{
        console.log('เกิดข้อผิดพลาด:', response)
        alert(`❌ ${response.data?.message || 'ไม่สามารถอัปโหลดไฟล์ได้'}`);
      }
    } catch (error) {
      console.error('Error uploading to PW:', error);
      const errorMessage = error.response?.data?.message || error.message || 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ';
      alert(`❌ ${errorMessage}`);
    } finally {
      setIsUploadingPW(false);
    }
  };


  const viewPWFileByDocId = async (docId) => {
    if(!docId){
      alert('ไม่มีไฟล์ในระบบ PW');
      return;
    }

    try {
      // ดาวน์โหลดไฟล์ผ่าน axios พร้อม token
      const response = await axios.get(`/api/file-pw/${docId}`, {
        headers: {
          'x-access-token': currentUser?.accessToken,
        },
        responseType: 'blob' // รับเป็น blob
      });

      // สร้าง blob URL และเปิดใน tab ใหม่
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      
      // ลบ URL ออกหลังจากเปิดแล้ว (ป้องกัน memory leak)
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error('Error viewing PW file:', error);
      alert('ไม่สามารถเปิดไฟล์ได้: ' + (error.response?.data?.message || error.message));
    }
  }

  const handleDeputyChange = async (event) => {
    console.log('handleDeputyChange', event.target.value);
    const empNo = event.target.value;
    if (empNo.length > 6) {
      const person = await getPersonByEmpNo(empNo);
      console.log('Person data:', person);
      // TODO: ใช้ข้อมูล person ที่ได้มา
    }
    // setValue({})
  };

  // แก้ปัญหา re-render
  function OthersSkill({ rhf, control }) {
    // const rhf = props.rhf;
    // const control = props.control;
    const [comment, setComment] = useState({ name: '' });
    // const handleChangeOthersSkill = (e) => {
    //   console.log('handleChangeOthersSkill ---> ' + e.target.value);
    //   setComment({ ...comment, name: e.target.value });
    //   // setComment({ name: 'aaaa' });
    // };

    const watchComment = useWatch({
      control,
      name: 'comment',
    });

    useEffect(() => {
      // console.log('comment:', watchComment);
      setComment({ ...comment, name: watchComment });
    }, [watchComment]);

    return (
      <rhf.Controller
        render={({ field, fieldState: { error } }) => (
          <TextField
            label={'รายละเอียด'}
            // name="comment"
            inputProps={{ maxLength: 100 }}
            // maxLength={100}
            helperText={`${comment?.name?.length || '0'}/100`}
            multiline
            maxRows={4}
            defaultValue={comment?.name}
            variant="filled"
            fullWidth
            {...field}
            // onChange={(e) => {
            //   field.onChange(e);
            //   console.log(e.target.value);
            //   handleChangeOthersSkill(e);
            // }}
          />
        )}
        name="comment"
        control={control}
      />
    );
  }

  // const [isฺBachelor, setIsBachelor] = useState(false);
  const arrBachelor = ['31', '51', '41', '21', '11'];

  function EduClassDegree({ control, index, replace, rhf }) {
    const edu = useWatch({
      control,
      name: 'educations',
    });

    const test = arrBachelor.find((e) => e == edu?.[index]?.eduClass)
      ? true
      : false;

    return (
      <>
        {/* {test && ( */}
        <>
          <Grid item xs={4} sm={4}>
            {/* ชื่อคุณวุฒิ */}
            <EduCertificate
              rhf={rhf}
              control={control}
              name={`educations[${index}].eduCertificate`}
            />
          </Grid>

          {/* คุณวุฒิอื่นๆ */}
          {edu?.[index]?.eduCertificate?.codeSAP === 'N/A' && (
            <Grid item xs={8} sm={8}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="ชื่อคุณวุฒิอื่นๆ (ระบุ)"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name={`educations[${index}].certificateOther`}
                control={control}
              />
            </Grid>
          )}
          <Grid item xs={8} sm={8}>
            {/* สาขาที่จบ */}
            <BranchOfStudies
              rhf={rhf}
              control={control}
              name={`educations[${index}].branchOfStudy`}
            />
          </Grid>

          {/* สาขาอื่นๆ */}
          {edu?.[index]?.branchOfStudy?.codeSAP === '99999' && (
            <Grid item xs={12} sm={12}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="ชื่อสาขาอื่นๆ (ระบุ)"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name={`educations[${index}].branchOther`}
                control={control}
              />
            </Grid>
          )}
          {/* <Grid item xs={2} sm={2}></Grid> */}

          <Grid item xs={3} sm={3}>
            {/* <TextField
                id="filled-basic"
                label="ปี พ.ศ ที่จบ"
                variant="filled"
                fullWidth
              /> */}
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
              <rhf.Controller
                control={control}
                name={`educations[${index}].graduateDate`}
                render={({
                  field: { onChange, value = null },
                  fieldState: { error },
                }) => (
                  <DatePicker
                    // views={['year']}
                    label="วันที่จบการศึกษา"
                    inputFormat="dd/MM/yyyy"
                    value={value}
                    onChange={onChange}
                    renderInput={(params) => (
                      <TextField
                        variant="filled"
                        fullWidth
                        {...params}
                        error={!!error}
                        helperText={error ? error.message : null}
                      />
                    )}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3} sm={3}>
            {/* ประเทศ */}
            <Country
              rhf={rhf}
              control={control}
              name={`educations[${index}].country`}
            />
          </Grid>
          {/* <Grid item xs={4} sm={4}>           
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="ในประเทศ / ต่างประเทศ"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name={`educations[${index}].inOutCountry`}
                control={control}
              />
            </Grid> */}
          <Grid item xs={3} sm={3}>
            {/* <TextField
                id="filled-basic"
                label="ประเภทสถานศึกษารัฐบาล/เอกชน"
                variant="filled"
                fullWidth
              /> */}
            <rhf.Controller
              render={({ field, fieldState: { error } }) => (
                <TextField
                  variant="filled"
                  label="ประเภทสถานศึกษารัฐบาล/เอกชน"
                  fullWidth
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              name={`educations[${index}].privateOrGovernment`}
              control={control}
            />
          </Grid>
          <Grid item xs={3} sm={3}>
            {/* <TextField
                id="filled-basic"
                label="ระยะเวลาหลักสูตร (ปี)"
                variant="filled"
                fullWidth
              /> */}
            <rhf.Controller
              render={({ field, fieldState: { error } }) => (
                <TextField
                  variant="filled"
                  label="ระยะเวลาหลักสูตร (ปี)"
                  fullWidth
                  type="number"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              name={`educations[${index}].duration`}
              control={control}
            />
          </Grid>
        </>
        {/* )} */}
      </>
    );
  }

  const [isMedicalProblem, setIsMedicalProblem] = useState('N');
  function MedicalProblem({ control }) {
    const isMedicalProblemData = useWatch({
      control,
      name: 'medicalProblem',
    });
    setIsMedicalProblem(isMedicalProblemData);

    return (
      <>
        {isMedicalProblem == 'Y' && (
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ระบุโรคประจำตัว"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="medicalProblemDetail"
            control={control}
          />
        )}
      </>
    );
  }

  const [hasCollegeActivity, setHasCollegeActivity] = useState('');
  const [hasEngineerCert, setHasEngineerCert] = useState('');
  const [hasWorkExperience, setHasWorkExperience] = useState('');
  const [hasMarried, setHasMarried] = useState('');

  const [
    checkCollegeActivity,
    // checkEngineerCert,
    checkHomeAddressProvince,
    checkWorkExperience,
    // checkHomeAddressDistrict,
    // checkPresentAddressProvince,
    // checkPresentAddressDistrict,
    // checkMarried,
  ] = useWatch({
    control,
    name: [
      'isCollegeActivity',
      // 'engineerCert',
      'homeAddressProvince',
      'isWorkExperience',
      // 'homeAddressDistrict',
      // 'presentAddressProvince',
      // 'presentAddressDistrict',
      // 'maritalStatus',
    ],
  });

  const checkEngineerCert = useWatch({
    control,
    name: 'engineerCert',
  });

  const checkMarried = useWatch({
    control,
    name: 'maritalStatus',
  });

  const checkWorkExperienceTotal = useWatch({
    control,
    name: 'workExperienceTotal',
  });

  const checkHomeAddressDistrict = useWatch({
    control,
    name: 'homeAddressDistrict',
  });

  const checkHomeAddressTambol = useWatch({
    control,
    name: 'homeAddressTambol',
  });

  const checkPresentAddressProvince = useWatch({
    control,
    name: 'presentAddressProvince',
  });

  const checkPresentAddressDistrict = useWatch({
    control,
    name: 'presentAddressDistrict',
  });

  const checkPresentAddressTambol = useWatch({
    control,
    name: 'presentAddressTambol',
  });

  const applicantIdWatch = useWatch({
    control,
    name: 'applicantId',
  });

  const idCardWatch = useWatch({
    control,
    name: 'idCard',
  });

  const hrHeadWatch = useWatch({
    control,
    name: 'hrHead',
  });

  useEffect(() => {
    console.log('useEffect.hrHeadWatch ---> ', hrHeadWatch);
  }, [hrHeadWatch]);

  useEffect(() => {
    //กิจกรรมพิเศษในสถานศึกษา
    if (checkCollegeActivity == 'Y') {
      setHasCollegeActivity('Y');
      collegeActivityAppend({});
    } else {
      setHasCollegeActivity('N');
      collegeActivityReplace([]);
    }
    //ใบอนุญาตประกอบวิชาชีพวิศวกรรม
    if (checkEngineerCert == 'Y') {
      setHasEngineerCert('Y');
    } else {
      setHasEngineerCert('N');
    }
    // ประสบการณ์ทำงาน;
    if (checkWorkExperience == 'Y') {
      // dispatch(setHasWorkExperienceRdx('Y'));
      setHasWorkExperience('Y');
      if (checkWorkExperienceTotal > 0) {
        //ถ้ามีค่าจาก DB ไม่ต้อง append
      } else {
        workExperienceAppend({});
      }
    } else {
      setHasWorkExperience('N');
      workExperienceReplace([]);
    }

    // console.log('----PersonalForm.jsx --> checkMarried4---', checkMarried);

    // สถานภาพ
    if (checkMarried != '0') {
      setHasMarried('Y');
    } else {
      setHasMarried('N');
    }
  }, [
    checkCollegeActivity,
    checkEngineerCert,
    checkWorkExperience,
    checkMarried,
  ]);

  //https://stackoverflow.com/questions/55075604/react-hooks-useeffect-only-on-update
  //ไม่ run ตอน initial
  //แยกกันแต่ละ useEffect, beware bug
  const isInitialMount = useRef(true);
  const isInitialMount2 = useRef(true);
  const isInitialMount3 = useRef(true);
  const isInitialMount4 = useRef(true);
  const isInitialMount5 = useRef(true);
  const isInitialMount6 = useRef(true);

  const prevHomeProvince = useRef();
  const prevHomeDistrict = useRef();
  const prevPresentProvince = useRef();
  const prevPresentDistrict = useRef();
  const prevHomeTambol = useRef();
  const prevPresentTambol = useRef();

  //เคลียร์อำเภอ ตำบล รหัสไปรษณีย์ เมื่อเปลี่ยนจังหวัด, home address
  useEffect(() => {
    console.log(
      'useEffect.checkHomeAddressProvince ---> ',
      checkHomeAddressProvince,
    );

    if (isInitialMount.current) {
      isInitialMount.current = false;
      prevHomeProvince.current = checkHomeAddressProvince;
      console.log('------->00001------>' + isInitialMount.current);
    } else {
      // เคลียร์เฉพาะเมื่อ province id เปลี่ยนจริงๆ (ไม่ใช่จาก undefined เป็นมีค่า)
      if (
        prevHomeProvince.current?.id !== checkHomeAddressProvince?.id &&
        prevHomeProvince.current?.id !== undefined
      ) {
        console.log('------->00002 CLEAR------>' + isInitialMount.current);
        setValue('homeAddressDistrict', {});
        setValue('homeAddressTambol', {});
        setValue('homeAddressPostal', '');
      }
      prevHomeProvince.current = checkHomeAddressProvince;
    }
    //{"id":1,"name":"พระนคร","provinceId":1}
  }, [checkHomeAddressProvince]);

  //เคลียร์ตำบล รหัสไปรษณีย์ เมื่อเปลี่ยนอำเภอ, home Address
  useEffect(() => {
    console.log(
      'useEffect.checkHomeAddressDistrict ---> ',
      checkHomeAddressDistrict,
    );

    if (isInitialMount2.current) {
      isInitialMount2.current = false;
      prevHomeDistrict.current = checkHomeAddressDistrict;
    } else {
      if (
        prevHomeDistrict.current?.id !== checkHomeAddressDistrict?.id &&
        prevHomeDistrict.current?.id !== undefined
      ) {
        setValue('homeAddressTambol', {});
        setValue('homeAddressPostal', '');
      }
      prevHomeDistrict.current = checkHomeAddressDistrict;
    }
  }, [checkHomeAddressDistrict]);

  //เคลียร์อำเภอ ตำบล รหัสไปรษณีย์ เมื่อเปลี่ยนจังหวัด, present address
  useEffect(() => {
    console.log(
      'useEffect.checkPresentAddressProvince ---> ',
      checkPresentAddressProvince,
    );

    if (isInitialMount3.current) {
      isInitialMount3.current = false;
      prevPresentProvince.current = checkPresentAddressProvince;
    } else {
      if (
        prevPresentProvince.current?.id !== checkPresentAddressProvince?.id &&
        prevPresentProvince.current?.id !== undefined
      ) {
        setValue('presentAddressDistrict', {});
        setValue('presentAddressTambol', {});
        setValue('presentAddressPostal', '');
      }
      prevPresentProvince.current = checkPresentAddressProvince;
    }
  }, [checkPresentAddressProvince]);

  //เคลียร์ตำบล รหัสไปรษณีย์ เมื่อเปลี่ยนอำเภอ, present Address
  useEffect(() => {
    console.log(
      'useEffect.checkPresentAddressDistrict ---> ',
      checkPresentAddressDistrict,
    );

    if (isInitialMount4.current) {
      isInitialMount4.current = false;
      prevPresentDistrict.current = checkPresentAddressDistrict;
    } else {
      if (
        prevPresentDistrict.current?.id !== checkPresentAddressDistrict?.id &&
        prevPresentDistrict.current?.id !== undefined
      ) {
        setValue('presentAddressTambol', {});
        setValue('presentAddressPostal', '');
      }
      prevPresentDistrict.current = checkPresentAddressDistrict;
    }
  }, [checkPresentAddressDistrict]);

  //เคลียร์รหัสไปรษณีย์ เมื่อเปลี่ยนตำบล, home Address
  useEffect(() => {
    console.log(
      'useEffect.checkHomeAddressTambol---> ',
      checkHomeAddressTambol,
    );

    if (isInitialMount5.current) {
      isInitialMount5.current = false;
      prevHomeTambol.current = checkHomeAddressTambol;
    } else {
      if (
        prevHomeTambol.current?.id !== checkHomeAddressTambol?.id &&
        prevHomeTambol.current?.id !== undefined
      ) {
        setValue('homeAddressPostal', '');
      }
      prevHomeTambol.current = checkHomeAddressTambol;
    }
  }, [checkHomeAddressTambol]);

  //เคลียร์รหัสไปรษณีย์ เมื่อเปลี่ยนตำบล, present Address
  useEffect(() => {
    console.log(
      'useEffect.checkPresentAddressTambol---> ',
      checkPresentAddressTambol,
    );

    if (isInitialMount6.current) {
      isInitialMount6.current = false;
      prevPresentTambol.current = checkPresentAddressTambol;
    } else {
      if (
        prevPresentTambol.current?.id !== checkPresentAddressTambol?.id &&
        prevPresentTambol.current?.id !== undefined
      ) {
        setValue('presentAddressPostal', '');
      }
      prevPresentTambol.current = checkPresentAddressTambol;
    }
  }, [checkPresentAddressTambol]);

  useEffect(() => {
    //เคลียร์ค่าเก่า
    dispatch(clearFileData());

    //ดึงไฟล์ที่เกี่ยวข้อง
    UploadService.getFileInfo2(idCardWatch)
      .then((files) => {
        files.data.map((file) => {
          // console.log('---PersonalFormHrInspect.jsx---file---', file);
          dispatch(
            setFileData({
              docType: file.empDocumentType,
              name: file.name,
              url: `/api/file/${file.id}`,
              data: file.data,
              type: file.type,
              pwData: file.pwData,
            }),
          );
        });
      })
      .catch((err) => {
        console.log('--------------getFileInfo2-----------', err);
        // dispatch( setFileData([]));
      });
  }, [idCardWatch]);

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: 'addressPass15yr',
  });

  const {
    fields: eduFields,
    append: eduAppend,
    remove: eduRemove,
  } = useFieldArray({
    control,
    name: 'educations',
  });

  const {
    fields: collegeActivityFields,
    append: collegeActivityAppend,
    remove: collegeActivityRemove,
    replace: collegeActivityReplace,
  } = useFieldArray({
    control,
    name: 'collegeActivity',
  });

  const {
    fields: languageSkillFields,
    append: languageSkillAppend,
    remove: languageSkillRemove,
    replace: languageSkillReplace,
  } = useFieldArray({
    control,
    name: 'othersLanguageSkill',
  });

  const {
    fields: workExperienceFields,
    append: workExperienceAppend,
    remove: workExperienceRemove,
    replace: workExperienceReplace,
  } = useFieldArray({
    control,
    name: 'workExperience',
  });

  const {
    fields: trainingHistoryFields,
    append: trainingHistoryAppend,
    remove: trainingHistoryRemove,
    replace: trainingHistoryReplace,
  } = useFieldArray({
    control,
    name: 'trainingHistory',
  });

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  const watchStartWorkDate = useWatch({
    control,
    name: 'startWorkDate',
  });

  const watchPSArea = useWatch({
    control,
    name: 'psArea',
  });
  const watchPSGroup = useWatch({
    control,
    name: 'psGroup',
  });
  const watchRoyalRankType = useWatch({
    control,
    name: 'royalRankType',
  });
  const watchRoyalRank = useWatch({
    control,
    name: 'royalRank',
  });

  // ใช้ useMemo เพื่อ cache ผลลัพธ์การ filter และลด re-calculation
  const filteredRoyalRanks = useMemo(() => {
    if (!watchRoyalRankType) return []; // ส่งกลับ [] ถ้ายังไม่เลือก royalRankType
    return getFilteredRoyalRanks(watchRoyalRankType);
  }, [watchRoyalRankType]);

  // ใช้ ref เพื่อตรวจสอบว่าเป็นครั้งแรกหรือไม่
  const isFirstRoyalRankTypeMount = useRef(true);

  useEffect(() => {
    console.log('Royal Rank Type:', watchRoyalRankType);

    // ไม่เคลียร์ค่า royalRank ในครั้งแรก (เพื่อให้แสดงค่า initial ได้)
    if (isFirstRoyalRankTypeMount.current) {
      isFirstRoyalRankTypeMount.current = false;
    } else {
      setValue('royalRank', ''); // เคลียร์ royalRank เมื่อ Royal Rank Type เปลี่ยน
    }

    setRoyalRankOptions(filteredRoyalRanks);
    console.log('Filtered Royal Ranks:', filteredRoyalRanks);
  }, [watchRoyalRankType, filteredRoyalRanks, setValue]);

  const watchBaseSalary = useWatch({
    control,
    name: 'baseSalary',
  });
  const watchIsHonorGraduate = useWatch({
    control,
    name: 'isHonorGraduate',
  });
  const watchHonorRate = useWatch({
    control,
    name: 'honorRate',
  });
  const watchEducations = useWatch({
    control,
    name: 'educations',
  });

  useEffect(() => {
    if (watchStartWorkDate) {
      // คำนวณวันที่ + 90 วัน
      const startDate = new Date(watchStartWorkDate);
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 90);

      // ตั้งค่า endWorkDate
      setValue('endWorkDate', endDate);
    }
  }, [watchStartWorkDate, setValue]);

  useEffect(() => {
    console.log('PS Area:', watchPSArea);
    setValue('baseSalary', 0); // เคลียร์ baseSalary เมื่อ PS Area เปลี่ยน

    // กรอง psGroupOptions ตาม psArea ที่เลือก
    const groups = psGroupByArea.filter(
      (group) => group.psArea === watchPSArea,
    );
    setPsGroupOptions(
      groups?.map((group) => ({
        value: group.psGroup,
        label: group.psGroup,
      })) || [],
    );
  }, [watchPSArea, setPsGroupOptions, setValue]);

  // อัปเดต baseSalary อัตโนมัติเมื่อ PS Area หรือ PS Group เปลี่ยนแปลง
  useEffect(() => {
    if (watchPSArea && watchPSGroup) {
      console.log('PS Area:', watchPSArea);
      console.log('PS Group:', watchPSGroup);
      // หา amount จาก psArea และ psGroup
      const foundAmount = amount.find(
        (opt) => opt.psArea === watchPSArea && opt.psGroup === watchPSGroup,
      );
      console.log('Found Amount:', foundAmount);
      if (foundAmount) {
        console.log('Setting baseSalary to:', foundAmount.amount);
        setValue('baseSalary', foundAmount.amount);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchPSArea, watchPSGroup, setValue]);

  useEffect(() => {
    if (watchBaseSalary !== undefined && watchBaseSalary !== null) {
      console.log('Base Salary changed:', watchBaseSalary);
      if (watchIsHonorGraduate === true) {
        // ถ้ามีเกียรตินิยมและยังไม่มีค่า honorRate ให้ตั้งค่า default 500
        if (!watchHonorRate) {
          setValue('honorRate', 500);
        }
      } else {
        setValue('honorRate', 0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchBaseSalary, watchIsHonorGraduate, setValue]);

  useEffect(() => {
    // คำนวณ salary = baseSalary + honorRate
    if (watchBaseSalary !== undefined && watchBaseSalary !== null) {
      const honorRateValue = watchHonorRate || 0;
      const totalSalary =
        parseFloat(watchBaseSalary) + parseFloat(honorRateValue);
      setValue('salary', totalSalary.toFixed(2));
      console.log('Calculated Salary:', {
        baseSalary: watchBaseSalary,
        honorRate: honorRateValue,
        totalSalary: totalSalary,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchBaseSalary, watchHonorRate, setValue]);

  useEffect(() => {

    if (watchEducations?.length > 0) {
      const foundMainEducation = watchEducations.find(
        (edu) => edu.isMainEducation == 1,
      );

      if (foundMainEducation) {
        const {
          honors: { id },
        } = foundMainEducation;
        [1].includes(id)
          ? setValue('isHonorGraduate', false)
          : setValue('isHonorGraduate', true);
        // setValue('mainEducation', foundMainEducation);
      } else {
        setValue('isHonorGraduate', false);
      }
    } else {
      setValue('isHonorGraduate', false);
    }
  }, [watchEducations, setValue]);

  const watchWorkHistory = useWatch({
    control,
    name: 'workExperience',
  });

  return (
    <React.Fragment>
      {/* {loader} */}
      {/* {isLoading && <CircularProgress />} */}

      {/* ปิดไว้ก่อน */}
      {/* {idCardWatch} */}
      {/* {applicantIdWatch}
      <Box p={0} display="flex">
        <H3>ตำแหน่งที่สมัคร</H3>
      </Box> */}

      {/* <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
        ตำแหน่งที่สมัคร
      </Typography> */}
      <Divider sx={{ mb: 3 }} />
      {/* <Paragraph sx={{ mb: '4px' }}>ประเภทอัตรา</Paragraph> */}
      <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
        ประเภทอัตรา
      </Typography>
      {/* padding bottom 3 */}
      <Grid item xs={12} sm={12} sx={{ pb: 3 }}>
        <Paper elevation={1}>
          <RadioFieldRHFRow
            isDisabled={true}
            name="positionType"
            label="positionType-label"
            rhf={rhf}
            options={positionTypeOptions}
            error={rhf.errors.positionType}
            // initial '' ที่ EmploymentPage ด้วย
          />
        </Paper>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="เลขที่ใบสมัคร"
                disabled
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="applicantNo"
            control={control}
          />
        </Grid>

        {/* ปิดตำแหน่ง ระดับ สังกัด ไว้ก่อน */}
        {/* <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ตำแหน่ง"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="position"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ระดับ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="level"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="รหัสตำแหน่ง"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="positionCode"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ฝ่าย/สังกัด"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="division"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="สายรอง"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="duputy"
            control={control}
          />
        </Grid> */}
      </Grid>
      <Box p={0} display="flex" sx={{ pb: 0, pt: 8 }}>
        <H3>ข้อมูลประวัติส่วนตัว</H3>
      </Box>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        <Grid item xs={3} sm={3}>
          <FormControl error={rhf.errors.title} variant="filled" fullWidth>
            <InputLabel>คำนำหน้า</InputLabel>
            <Controller
              render={({ field: { onChange, value } }) => (
                <Select onChange={onChange} value={value}>
                  {titleOptions.map((title) => (
                    <MenuItem key={title.value} value={title.value}>
                      {title.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              control={control}
              name="title"
            />
            <FormHelperText error={rhf.errors.title}>
              {rhf.errors.title ? '(' + rhf.errors.title.message + ')' : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* <InputField name={firstName.name} label={firstName.label} fullWidth /> */}
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ชื่อ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="firstName"
            control={control}
          />
          {/* {error.firstName && <p>{error.firstName.message}</p>} */}
        </Grid>
        <Grid item xs={5} sm={5}>
          {/* <InputField name={lastName.name} label={lastName.label} fullWidth /> */}
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="นามสกุล"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="lastName"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <Engtitle rhf={rhf} control={control} name={`engTitle`} />
        </Grid>
        <Grid item xs={9} sm={9}>
          {/* <InputField name={nameEng.name} label={nameEng.label} fullWidth /> */}
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ชื่อ-นามสกุล (ภาษาอังกฤษตัวพิมพ์ใหญ่)"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="nameEng"
            control={control}
          />
        </Grid>

        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="เลขประจำตัวประชาชน"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="idCard"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
            {/* <LocalizationProvider adapterLocale={th}> */}
            <rhf.Controller
              control={control}
              name="birthdate"
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <DesktopDatePicker
                  label="วัน/เดือน/ปีเกิด"
                  inputFormat="dd/MM/yyyy"
                  value={value}
                  onChange={onChange}
                  renderInput={(params) => (
                    <TextField
                      variant="filled"
                      fullWidth
                      {...params}
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="สัญชาติ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="empNationality"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <Province
            rhf={rhf}
            control={control}
            name="placeOfBirth"
            label="ภูมิลำเนา"
          />
          {/* <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ภูมิลำเนา"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="placeOfBirth"
            control={control}
          /> */}
        </Grid>
        <Grid item xs={4} sm={4}></Grid>

        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="น้ำหนัก"
                fullWidth
                type="number"
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="empWeight"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ส่วนสูง"
                fullWidth
                error={!!error}
                type="number"
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="empHeight"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}></Grid>

        <Grid item xs={4} sm={4}>
          <Controller
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                options={royalRankTypeOptions || []}
                getOptionLabel={(option) => option.label || ''}
                value={
                  royalRankTypeOptions?.find((opt) => opt.id == value) || null
                }
                onChange={(_, data) => onChange(data?.id || '')}
                isOptionEqualToValue={(option, value) => {
                  if (!value) return false;
                  return option.id == (value.id || value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="ประเภทยศ"
                    variant="filled"
                    error={!!rhf.errors.royalRankType}
                    helperText={rhf.errors.royalRankType?.message || ''}
                  />
                )}
              />
            )}
            control={control}
            name={`royalRankType`}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <Controller
            render={({ field: { onChange, value } }) => {
              // ใช้ filteredRoyalRanks ถ้ามี ถ้าไม่มีและมีค่า value ให้ใช้ royalRank ทั้งหมดเพื่อหาค่า initial
              const options =
                filteredRoyalRanks.length > 0
                  ? filteredRoyalRanks
                  : value
                    ? royalRank
                    : [];

              // หาค่าที่จะแสดง - ถ้าเป็น object ใช้เลย ถ้าเป็น string หาจาก options หรือสร้างเป็น object
              const displayValue =
                options?.find((opt) => opt.value == value) ||
                (value ? { value, label: value } : null);

              return (
                <Autocomplete
                  freeSolo
                  options={options || []}
                  getOptionLabel={(option) => {
                    if (typeof option === 'string') return option;
                    return option.label || option.value || '';
                  }}
                  value={displayValue}
                  onChange={(_, data) => {
                    if (typeof data === 'string') {
                      onChange(data); // ถ้าพิมพ์เอง
                    } else {
                      onChange(data?.value || ''); // ถ้าเลือกจาก options
                    }
                  }}
                  onInputChange={(_, newInputValue, reason) => {
                    if (reason === 'input' || reason === 'clear') {
                      onChange(newInputValue);
                    }
                  }}
                  isOptionEqualToValue={(option, value) => {
                    if (!value) return false;
                    return option.value == (value.value || value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="ยศ"
                      variant="filled"
                      error={!!rhf.errors.royalRank}
                      helperText={rhf.errors.royalRank?.message || ''}
                    />
                  )}
                />
              );
            }}
            control={control}
            name={`royalRank`}
          />
        </Grid>

        <Grid item xs={3} sm={3}></Grid>
        <Grid item xs={3} sm={3}></Grid>
        <Grid item xs={3} sm={3}></Grid>
        <Grid item xs={3} sm={3}></Grid>

        <Grid item xs={12} sm={12}>
          {/* <Paper elevation={1}> */}
          <Typography
            sx={{ pb: 0, pt: 1, pl: 2 }}
            variant="subtitle1"
            gutterBottom
          >
            โรคประจำตัว
          </Typography>
          <Paper elevation={1}>
            <Grid item xs={6} sm={6}>
              <RadioFieldRHFRow
                name="medicalProblem"
                label="medicalProblem-label"
                rhf={rhf}
                options={optionsMedicalProblem}
                // error={rhf.errors.medicalProblem}
                // initial '' ที่ EmploymentPage ด้วย
              />
              <FormHelperText error={true} sx={{ pl: 6 }}>
                {rhf.errors?.medicalProblem &&
                  rhf.errors.medicalProblem.message}
              </FormHelperText>
            </Grid>
            <Grid item xs={6} sm={6} sx={{ pl: 6, pb: 3 }}>
              <MedicalProblem control={control} />
            </Grid>
          </Paper>
          {/* <RadioFieldRHF
            name="medicalProblem"
            label="ระบุโรคประจำตัว"
            rhf={rhf}
            options={optionsMedicalProblem}
            // initial '' ที่ EmploymentPage ด้วย
          />
          <FormHelperText error={true}>
            {rhf.errors?.medicalProblem && rhf.errors.medicalProblem.message}
          </FormHelperText> */}
          {/* </Paper> */}
        </Grid>
        {/* <Grid item xs={2} sm={2}> */}
        {/* <MedicalProblem control={control} /> */}
        {/* </Grid> */}
        {/* <Grid item xs={4} sm={4}></Grid> */}
      </Grid>
      <Box p={0} display="flex" sx={{ pb: 0, pt: 6 }}>
        <H3>ที่อยู่</H3>
      </Box>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        {/* 
        |
        |
        | ที่อยู่ตามทะเบียนบ้าน
        |
        |
        */}
        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 1 }} variant="subtitle1" gutterBottom>
            ที่อยู่ตามทะเบียนบ้าน
          </Typography>
        </Grid>
        <Grid item xs={9} sm={9}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="หมู่บ้าน อาคาร บ้านเลขที่ หมู่ที่ ซอย ถนน "
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="homeAddressNo"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}></Grid>

        {/* จังหวัด */}
        <Grid item xs={3} sm={3}>
          <Province rhf={rhf} control={control} name="homeAddressProvince" />
        </Grid>
        {/* อำเภอ */}
        <Grid item xs={3} sm={3}>
          <District
            rhf={rhf}
            control={control}
            name="homeAddressDistrict"
            province={checkHomeAddressProvince}
          />
        </Grid>
        {/* ตำบล */}
        <Grid item xs={3} sm={3}>
          <Tambol
            rhf={rhf}
            control={control}
            name="homeAddressTambol"
            province={checkHomeAddressProvince}
            district={checkHomeAddressDistrict}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="รหัสไปรษณีย์"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="homeAddressPostal"
            control={control}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 7 }} variant="subtitle1" gutterBottom>
            ที่อยู่ปัจจุบันที่สามารถติดต่อได้
          </Typography>
        </Grid>
        <Grid item xs={9} sm={9}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="บ้านเลขที่ หมู่ที่ อาคาร หมู่บ้าน ซอย ถนน"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressNo"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}></Grid>

        <Grid item xs={3} sm={3}>
          {/* จังหวัด */}
          <Province rhf={rhf} control={control} name="presentAddressProvince" />
        </Grid>
        <Grid item xs={3} sm={3}>
          {/* อำเภอ */}
          <District
            rhf={rhf}
            control={control}
            name="presentAddressDistrict"
            province={checkPresentAddressProvince}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <Tambol
            rhf={rhf}
            control={control}
            name="presentAddressTambol"
            province={checkPresentAddressProvince}
            district={checkPresentAddressDistrict}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="รหัสไปรษณีย์"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressPostal"
            control={control}
          />
        </Grid>
        <Grid item xs={4} sm={4}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="โทรศัพท์มือถือ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressCellPhone"
            control={control}
          />
        </Grid>
        <Grid item xs={5} sm={5}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="E-mail"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="presentAddressEmail"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}></Grid>

        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 7 }} variant="subtitle1" gutterBottom>
            บุคคลที่ติดต่อได้ในกรณีเร่งด่วน
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2}>
          <FormControl error={rhf.errors.title} variant="filled" fullWidth>
            <InputLabel>คำนำหน้า</InputLabel>
            <Controller
              render={({ field: { onChange, value } }) => (
                <Select onChange={onChange} value={value}>
                  {titleOptions.map((title) => (
                    <MenuItem key={title.value} value={title.value}>
                      {title.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              control={control}
              name="emergencyTitle"
            />
            <FormHelperText error={rhf.errors.title}>
              {rhf.errors.title ? '(' + rhf.errors.title.message + ')' : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ชื่อ"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="emergencyFirstName"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="สกุล"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="emergencyLastName"
            control={control}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="เกี่ยวข้องเป็น"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="emergencyRelation"
            control={control}
          />
        </Grid>
        <Grid item xs={2} sm={2}></Grid>

        <Grid item xs={7} sm={7}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="บ้านเลขที่ หมู่ที่ ซอย ถนน ตำบล อำเภอ จังหวัด"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="emergencyAddress"
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="โทรศัพท์"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="emergencyPhone"
            control={control}
          />
        </Grid>
        <Grid item xs={2} sm={2}></Grid>
      </Grid>
      {/* <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 5 }} variant="subtitle1" gutterBottom>
            ไปปฏิบัติงานต่างจังหวัด
          </Typography>
        </Grid> */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 8 }}>
        <H3>ไปปฏิบัติงานต่างจังหวัด</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={4} sm={4}>
          <Paper elevation={1}>
            <Typography
              sx={{ pb: 2, pt: 1, pl: 2, pr: 2 }}
              variant="subtitle1"
              gutterBottom
            >
              หากต้องไปปฏิบัติงานต่างจังหวัดเป็นการประจำ
            </Typography>
            <RadioFieldRHF
              name="workOnRemoteSite"
              label="ไปปฏิบัติงานต่างจังหวัด"
              rhf={rhf}
              options={optionsWorkOnRemoteSite}
              // initial '' ที่ EmploymentPage ด้วย, and shift F5
            />
          </Paper>
        </Grid>
        <Grid item xs={4} sm={4}>
          <Paper elevation={1}>
            <Typography
              sx={{ pb: 2, pt: 1, pl: 2, pr: 2 }}
              variant="subtitle1"
              gutterBottom
            >
              หากต้องไปปฏิบัติงานต่างจังหวัดเป็นครั้งคราว
            </Typography>
            <RadioFieldRHF
              name="workOnRemoteSiteOccasion"
              label="ไปปฏิบัติงานต่างจังหวัดเป็นครั้งคราว"
              rhf={rhf}
              options={optionsWorkOnRemoteSite}
              // initial '' ที่ EmploymentPage ด้วย, and shift F5
            />
          </Paper>
        </Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>
      {/* 
      |
      |
      | ประวัติการศึกษา
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ประวัติการศึกษา</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          {/* <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            ประวัติการศึกษาตั้งแต่ชั้นอนุบาล จนถึงชั้นสูงสุดที่สำเร็จการศึกษา
          </Typography> */}
        </Grid>

        {eduFields.map((item, index) => {
          return (
            <>
              <Grid
                item
                xs={2}
                sm={2}
                component={Stack}
                justifyContent="flex-start"
                alignItems="flex-end"
              >
                <Typography
                  sx={{
                    pb: 0,
                    pt: 0,
                    color: 'success.main',
                  }}
                  variant="subtitle1"
                  gutterBottom
                >
                  {index != 0 && `การศึกษาที่ ${index + 1}`}
                </Typography>
              </Grid>
              <Grid item xs={2} sm={2}>
                {index != 0 && (
                  <Button
                    variant="outlined"
                    startIcon={<DeleteOutlineIcon />}
                    onClick={() => eduRemove(index)}
                  >
                    ลบ
                  </Button>
                )}
              </Grid>
              <Grid item xs={8} sm={8}></Grid>
              {/* <Grid item xs={2} sm={2}>
                <div key={item.id}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="ระยะเวลา (ปี)"
                        fullWidth
                        type="number"
                        error={!!error}
                        InputProps={{
                          inputProps: {
                            max: 50,
                            min: 1,
                          },
                        }}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`educations[${index}].period`}
                    control={control}
                  />
                </div>
              </Grid> */}
              <Grid item xs={12} sm={12}>
                <Controller
                  name={`educations[${index}].isMainEducation`}
                  control={control}
                  render={({ field }) =>
                    isMainEducationOptions?.map((singleOption) => (
                      <FormControlLabel
                        key={singleOption.id}
                        label={singleOption.name}
                        control={
                          <Checkbox
                            onChange={(event, checked) => {
                              field.onChange(checked ? singleOption.id : null);
                            }}
                            checked={field.value == singleOption.id}
                          />
                        }
                      />
                    ))
                  }
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                {/* <EduDegree
                  rhf={rhf}
                  control={control}
                  name={`educations[${index}].eduClass`}
                /> */}
                <FormControl variant="filled" fullWidth>
                  <InputLabel>ระดับชั้น / หลักสูตร</InputLabel>
                  <Controller
                    render={({ field: { onChange, value } }) => (
                      <Select onChange={onChange} value={value} defaultValue="">
                        {eduClass.map((clss) => (
                          <MenuItem key={clss.code} value={clss.code}>
                            {clss.name}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                    control={control}
                    name={`educations[${index}].eduClass`}
                  />

                  <FormHelperText
                    error={rhf.errors.educations?.[index]?.eduClass}
                  >
                    {rhf.errors.educations?.[index]?.eduClass
                      ? '(' +
                        rhf.errors.educations?.[index]?.eduClass?.message +
                        ')'
                      : ''}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={8} sm={8}>
                <EduInstitution
                  rhf={rhf}
                  control={control}
                  name={`educations[${index}].eduNameAndPlace`}
                />

                {/* <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="ชื่อและที่ตั้งสถานศึกษา"
                      fullWidth
                      disabled
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`educations[${index}].eduNameAndPlace`}
                  control={control}
                /> */}
              </Grid>

              {/* สถาบันอื่นๆ */}
              {watchEducations?.[index]?.eduNameAndPlace?.codeSAP ===
                '99999999' && (
                <Grid item xs={12} sm={12}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="ชื่อสถาบันอื่นๆ (ระบุ)"
                        fullWidth
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`educations[${index}].instituteOther`}
                    control={control}
                  />
                </Grid>
              )}
              {/* <Grid item xs={2} sm={2}></Grid> */}
              {/* gg: mui year picker */}
              <Grid item xs={3} sm={3}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                  <rhf.Controller
                    control={control}
                    name={`educations[${index}].dateFrom`}
                    render={({
                      field: { onChange, value = null },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        views={['year']}
                        label="ระยะเวลาจาก"
                        // inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField
                            variant="filled"
                            onKeyDown={onKeyDown}
                            fullWidth
                            {...params}
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3} sm={3}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                  <rhf.Controller
                    control={control}
                    name={`educations[${index}].dateTo`}
                    render={({
                      field: { onChange, value = null },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        views={['year']}
                        label="ถึง"
                        // inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField
                            variant="filled"
                            fullWidth
                            {...params}
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    )}
                  />
                  {/* <rhf.Controller
                    control={control}
                    name={`educations[${index}].dateTo`}
                    render={({ field: { onChange, value = null } }) => (
                      <DesktopDatePicker
                        label="ถึง"
                        inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField variant="filled" fullWidth {...params} />
                        )}
                      />
                    )}
                  /> */}
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3} sm={3}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="เกรดเฉลี่ย/ผลการศึกษา"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`educations[${index}].eduGradeScore`}
                  control={control}
                />
              </Grid>
              <Grid item xs={3} sm={3}>
                {/* เกียรตินิยม */}
                <Honors
                  rhf={rhf}
                  control={control}
                  name={`educations[${index}].honors`}
                  label="เกียรตินิยม"
                />
              </Grid>
              {/* <Grid item xs={2} sm={2}></Grid> */}

              <EduClassDegree
                control={control}
                index={index}
                rhf={rhf}
                // replace={replace}
              />

              <Grid item xs={12} sm={12}></Grid>
            </>
          );
        })}
        {/* <Grid item xs={2} sm={2}>
          <Button
            variant="outlined"
            onClick={() => {
              eduAppend({ period: '' });
            }}
          >
            + เพิ่มการศึกษา
          </Button>
        </Grid> */}

        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ระดับการศึกษา/คุณวุฒิที่สมัคร</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Paper elevation={1}>
            <RadioFieldRHFRow
              name="eduOnApplicant"
              label="eduOnApplicant-label"
              rhf={rhf}
              options={eduOnApplicant}
              error={rhf.errors.eduOnApplicant}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
      </Grid>
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ใบอนุญาตประกอบวิชาชีพวิศวกรรม (ถ้ามี)</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            **ใบอนุญาตประกอบวิชาชีพวิศวกรรมควบคุม ในสาขาตามที่กฎหมายกำหนด จำนวน
            7 สาขา ได้แก่ สาขาวิศวกรรมโยธา 
            วิศวกรรมเหมืองแร่ วิศวกรรมเครื่องกล วิศวกรรมไฟฟ้า วิศวกรรมอุตสาหการ วิศวกรรมสิ่งแวดล้อม และวิศวกรรมเคมี
            ต้องนำใบอนุญาตดังกล่าวมาแสดงต่อ กฟผ. ภายใน 1
            ปี นับแต่วันที่เข้าทำงานกับ กฟผ.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Paper elevation={1}>
            <RadioFieldRHFRow
              name="engineerCert"
              label="engineerCert-label"
              rhf={rhf}
              options={engineerCert}
              error={rhf.errors.engineerCert}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
        {hasEngineerCert == 'Y' && (
          <>
            <Grid item xs={4} sm={4}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="เลขที่ใบประกอบวิชาชีพ (License No. เช่น ภฟก.xxxxx)"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="engineerCertNo"
                control={control}
              />
            </Grid>
            <Grid item xs={5} sm={5}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="หน่วยงานผู้ออกใบประกอบวิชาชีพ (ไม่เกิน 30 ตัวอักษร)"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="engineerCertProvider"
                control={control}
              />
            </Grid>
            <Grid item xs={3} sm={3}></Grid>
            <Grid item xs={4} sm={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                {/* <LocalizationProvider adapterLocale={th}> */}
                <rhf.Controller
                  control={control}
                  name="engineerCertStartDate"
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <DesktopDatePicker
                      label="วันอนุญาต"
                      inputFormat="dd/MM/yyyy"
                      value={value}
                      onChange={onChange}
                      renderInput={(params) => (
                        <TextField
                          variant="filled"
                          fullWidth
                          {...params}
                          error={!!error}
                          helperText={error ? error.message : null}
                        />
                      )}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={4} sm={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                {/* <LocalizationProvider adapterLocale={th}> */}
                <rhf.Controller
                  control={control}
                  name="engineerCertEndDate"
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <DesktopDatePicker
                      label="วันหมดอายุ"
                      inputFormat="dd/MM/yyyy"
                      value={value}
                      onChange={onChange}
                      renderInput={(params) => (
                        <TextField
                          variant="filled"
                          fullWidth
                          {...params}
                          error={!!error}
                          helperText={error ? error.message : null}
                        />
                      )}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={4} sm={4}></Grid>
            <Grid item xs={4} sm={4}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="หมายเลขสมาชิกสภาวิศวกร (Member No. 6 หลัก)"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="engineerCertMemberNo"
                control={control}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <FormControl
                error={rhf.errors.engineerCertType}
                variant="filled"
                fullWidth
              >
                <InputLabel>ประเภทใบ กว.</InputLabel>
                <Controller
                  render={({ field: { onChange, value } }) => (
                    <Select onChange={onChange} value={value} defaultValue="">
                      {engineerCertType.map((el) => (
                        <MenuItem key={el.value} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  control={control}
                  name={`engineerCertType`}
                />
                <FormHelperText error={rhf.errors.engineerCertType}>
                  {rhf.errors.engineerCertType
                    ? rhf.errors.engineerCertType.message
                    : ''}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={4} sm={4}></Grid>
            <Grid item xs={4} sm={4}>
              <FormControl
                error={rhf.errors.engineerCertBranch}
                variant="filled"
                fullWidth
              >
                <InputLabel>สาขา</InputLabel>
                <Controller
                  render={({ field: { onChange, value } }) => (
                    <Select onChange={onChange} value={value} defaultValue="">
                      {engineerCertBranch.map((el) => (
                        <MenuItem key={el.value} value={el.value}>
                          {el.label}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  control={control}
                  name={`engineerCertBranch`}
                />
                <FormHelperText error={rhf.errors.engineerCertBranch}>
                  {rhf.errors.engineerCertBranch
                    ? rhf.errors.engineerCertBranch.message
                    : ''}
                </FormHelperText>
              </FormControl>
            </Grid>
          </>
        )}
      </Grid>
      {/* 
      |
      |
      | ภาษาต่างประเทศ
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ภาษาต่างประเทศ</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={2} sm={2}>
          <Typography
            //margin-top : 2
            sx={{ pb: 0, pt: 0, mt: 2 }}
            variant="subtitle1"
            gutterBottom
          >
            ภาษาอังกฤษ
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2}>
          <FormControl
            error={rhf.errors.englishLanguageSkillSpeak}
            variant="filled"
            fullWidth
          >
            <InputLabel>พูด</InputLabel>
            <Controller
              render={({ field }) => {
                return (
                  <Select {...field} value={field.value || ''}>
                    {languageSkill.map((level) => (
                      <MenuItem key={level.value} value={level.value}>
                        {level.label}
                      </MenuItem>
                    ))}
                  </Select>
                );
              }}
              control={control}
              name="englishLanguageSkillSpeak"
            />
            <FormHelperText error={rhf.errors.englishLanguageSkillSpeak}>
              {rhf.errors.englishLanguageSkillSpeak
                ? '(' + rhf.errors.englishLanguageSkillSpeak.message + ')'
                : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2}>
          <FormControl
            error={rhf.errors.englishLanguageSkillRead}
            variant="filled"
            fullWidth
          >
            <InputLabel>อ่าน</InputLabel>
            <Controller
              render={({ field }) => {
                return (
                  <Select {...field} value={field.value || ''}>
                    {languageSkill.map((level) => (
                      <MenuItem key={level.value} value={level.value}>
                        {level.label}
                      </MenuItem>
                    ))}
                  </Select>
                );
              }}
              control={control}
              name="englishLanguageSkillRead"
            />
            <FormHelperText error={rhf.errors.englishLanguageSkillRead}>
              {rhf.errors.englishLanguageSkillRead
                ? '(' + rhf.errors.englishLanguageSkillRead.message + ')'
                : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2}>
          <FormControl
            error={rhf.errors.englishLanguageSkillWrite}
            variant="filled"
            fullWidth
          >
            <InputLabel>เขียน</InputLabel>
            <Controller
              render={({ field }) => {
                return (
                  <Select {...field} value={field.value || ''}>
                    {languageSkill.map((level) => (
                      <MenuItem key={level.value} value={level.value}>
                        {level.label}
                      </MenuItem>
                    ))}
                  </Select>
                );
              }}
              control={control}
              name="englishLanguageSkillWrite"
            />
            <FormHelperText error={rhf.errors.englishLanguageSkillWrite}>
              {rhf.errors.englishLanguageSkillWrite
                ? '(' + rhf.errors.englishLanguageSkillWrite.message + ')'
                : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={3} sm={3}></Grid>

        {/* 
        |
        |
        | ภาษาต่างประเทศ อื่นๆ 
        |
        |
        */}
        {languageSkillFields.map((item, index) => {
          return (
            <>
              <Grid item xs={2} sm={2}>
                <Language
                  rhf={rhf}
                  control={control}
                  name={`othersLanguageSkill[${index}].languageSkill`}
                ></Language>
                {/* <rhf.Controller
                  render={({ field, fieldState: { error }, control }) => (
                    <TextField
                      variant="filled"
                      label="ภาษา"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`othersLanguageSkill[${index}].languageSkill`}
                  control={control}
                /> */}
              </Grid>
              <Grid item xs={2} sm={2}>
                <FormControl
                  // error={rhf.errors.othersLanguageSkill}
                  variant="filled"
                  fullWidth
                >
                  <InputLabel>พูด</InputLabel>
                  <Controller
                    render={({ field: { onChange, value } }) => (
                      <Select onChange={onChange} value={value || ''}>
                        {languageSkill.map((level) => (
                          <MenuItem key={level.value} value={level.value}>
                            {level.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                    control={control}
                    name={`othersLanguageSkill[${index}].speak`}
                  />
                  <FormHelperText
                    error={rhf.errors.othersLanguageSkill?.[index].speak}
                  >
                    {rhf.errors.othersLanguageSkill?.[index].speak
                      ? '(' +
                        rhf.errors.othersLanguageSkill?.[index].speak.message +
                        ')'
                      : ''}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2}>
                <FormControl
                  // error={rhf.errors.englishLanguageSkillRead}
                  variant="filled"
                  fullWidth
                >
                  <InputLabel>อ่าน</InputLabel>
                  <Controller
                    render={({ field: { onChange, value } }) => (
                      <Select onChange={onChange} value={value || ''}>
                        {languageSkill.map((level) => (
                          <MenuItem key={level.value} value={level.value}>
                            {level.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                    control={control}
                    name={`othersLanguageSkill[${index}].read`}
                  />
                  {/* <FormHelperText error={rhf.errors.englishLanguageSkillRead}>
                    {rhf.errors.englishLanguageSkillRead
                      ? '(' + rhf.errors.englishLanguageSkillRead.message + ')'
                      : ''}
                  </FormHelperText> */}
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2}>
                <FormControl
                  error={rhf.errors.englishLanguageSkillWrite}
                  variant="filled"
                  fullWidth
                >
                  <InputLabel>เขียน</InputLabel>
                  <Controller
                    render={({ field: { onChange, value } }) => (
                      <Select onChange={onChange} value={value || ''}>
                        {languageSkill.map((level) => (
                          <MenuItem key={level.value} value={level.value}>
                            {level.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                    control={control}
                    name={`othersLanguageSkill[${index}].write`}
                  />
                  {/* <FormHelperText error={rhf.errors.englishLanguageSkillWrite}>
                    {rhf.errors.englishLanguageSkillWrite
                      ? '(' + rhf.errors.englishLanguageSkillWrite.message + ')'
                      : ''}
                  </FormHelperText> */}
                </FormControl>
              </Grid>

              <Grid item xs={1} sm={1}>
                <Button
                  variant="outlined"
                  startIcon={<DeleteOutlineIcon />}
                  onClick={() => languageSkillRemove(index)}
                >
                  ลบ
                </Button>
              </Grid>
              <Grid item xs={3} sm={3}></Grid>
            </>
          );
        })}
        <Grid item xs={12} sm={12}></Grid>
        <Grid item xs={2} sm={2}>
          <Button
            variant="outlined"
            onClick={() => {
              languageSkillAppend({
                languageSkill: {
                  id: '',
                  codeSAP: '',
                  name: '',
                },
                speak: '',
                read: '',
                write: '',
                certificate: '',
              });
            }}
          >
            + เพิ่มภาษา
          </Button>
        </Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>
      {/* 
      |
      |
      | คะแนนภาษาอังกฤษ
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>คะแนนภาษาอังกฤษ</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={3} sm={3}>
          <FormControl
            error={rhf.errors.englishLanguageCertificate}
            variant="filled"
            fullWidth
          >
            {/* https://stackoverflow.com/questions/62933583/material-ui-autocomplete-getoptionlabel-passing-empty-string-as-value
            https://stackoverflow.com/questions/71485196/react-hook-form-with-mui-autocomplete-freesolo-and-dependent-fields
            https://codesandbox.io/s/react-hook-form-v6-controller-qsd8r?file=/src/MuiAutoComplete.js
            https://mui.com/material-ui/react-autocomplete/#free-solo
            https://medium.com/nerd-for-tech/demystifying-errors-in-mui-autocomplete-part-i-e306f922a906 */}
            <rhf.Controller
              render={({ field, fieldState: { error }, value }) => (
                <Autocomplete
                  {...field}
                  freeSolo
                  id="languageSkillSelect"
                  options={languageCertificate}
                  // getOptionLabel={(option) => option.name}
                  // value={value}
                  onChange={(_, data) => field.onChange(data)}
                  onInputChange={(_, data) => {
                    if (data) field.onChange(data);
                    // field.onChange(data);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="ประกาศณียบัตรทางภาษา"
                      variant="filled"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                />
              )}
              name="englishLanguageCertificate"
              control={control}
            />
          </FormControl>
        </Grid>
        <Grid item xs={3} sm={3}>
          <FormControl
            error={rhf.errors.englishLanguageCertificateScore}
            variant="filled"
            fullWidth
          >
            {/* https://stackoverflow.com/questions/62933583/material-ui-autocomplete-getoptionlabel-passing-empty-string-as-value
            https://stackoverflow.com/questions/71485196/react-hook-form-with-mui-autocomplete-freesolo-and-dependent-fields
            https://codesandbox.io/s/react-hook-form-v6-controller-qsd8r?file=/src/MuiAutoComplete.js
            https://mui.com/material-ui/react-autocomplete/#free-solo
            https://medium.com/nerd-for-tech/demystifying-errors-in-mui-autocomplete-part-i-e306f922a906 */}
            <rhf.Controller
              render={({ field, fieldState: { error }, value }) => (
                <TextField
                  {...field}
                  label="คะแนน"
                  variant="filled"
                  fullWidth
                  error={!!error}
                  helperText={error ? error.message : null}
                />
              )}
              name="englishLanguageCertificateScore"
              control={control}
            />
          </FormControl>
        </Grid>
        <Grid item xs={3} sm={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
            <rhf.Controller
              control={control}
              name={`englishLanguageCertificateDate`}
              render={({
                field: { onChange, value = null },
                fieldState: { error },
              }) => (
                <DatePicker
                  // views={['year']}
                  label="วันที่สอบ"
                  inputFormat="dd/MM/yyyy"
                  value={value}
                  onChange={onChange}
                  renderInput={(params) => (
                    <TextField
                      variant="filled"
                      fullWidth
                      {...params}
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        {/* <Grid item xs={3} sm={3}>
          <FormControl
            error={rhf.errors.englishLanguageCertificateNo}
            variant="filled"
            fullWidth
          >
            <rhf.Controller
              render={({ field, fieldState: { error }, value }) => (
                <TextField
                  {...field}
                  label="เลขที่เอกสาร"
                  variant="filled"
                  fullWidth
                  error={!!error}
                  helperText={error ? error.message : null}
                />
              )}
              name="englishLanguageCertificateNo"
              control={control}
            />
          </FormControl>
        </Grid> */}
      </Grid>
      {/* 
      |
      |
      | ประสบการณ์การทำงาน
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ประสบการณ์การทำงาน</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            *ประวัติการทำงานกับบริษัทเอกชน หรือราชการอื่นๆรวมทั้งเหตุผลที่ออก
            เช่น เปลี่ยนงานใหม่ ย้ายสถานที่ทำงาน เป็นต้น
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Paper elevation={1}>
            {/* <WorkExperiece /> */}
            <RadioFieldRHFRow
              name="isWorkExperience"
              label="isWorkExperience-label"
              rhf={rhf}
              options={workExperienceOptions}
              error={rhf.errors.isWorkExperience}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
        {/* {hasWorkExperienceRdx} */}

        {hasWorkExperience == 'Y' &&
          workExperienceFields.map((item, index) => {
            return (
              <>
                <Grid
                  item
                  xs={3}
                  sm={3}
                  component={Stack}
                  justifyContent="flex-start"
                  alignItems="flex-end"
                >
                  <Typography
                    sx={{
                      pb: 0,
                      pt: 0,
                      color: 'success.main',
                    }}
                    variant="subtitle1"
                    gutterBottom
                  >
                    {index != 0 && `การทำงานหน่วยงานที่ ${index + 1}`}
                  </Typography>
                </Grid>
                <Grid item xs={7} sm={7}></Grid>

                <Grid item xs={4} sm={4}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="ชื่อหน่วยงาน"
                        fullWidth
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`workExperience[${index}].workName`}
                    control={control}
                  />
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Career
                    rhf={rhf}
                    control={control}
                    name={`workExperience[${index}].workDuty`}
                  />
                  {/* <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="ตำแหน่ง"
                        fullWidth
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`workExperience[${index}].workDuty`}
                    control={control}
                  /> */}
                </Grid>
                {watchWorkHistory?.[`${index}`]?.workDuty?.codeSAP ==
                  '00000098' && (
                  <Grid item xs={4} sm={4}>
                    <rhf.Controller
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          variant="filled"
                          label="ตำแหน่งอื่นๆ (ระบุ)"
                          fullWidth
                          error={!!error}
                          helperText={error ? error.message : null}
                          {...field}
                        />
                      )}
                      name={`workExperience[${index}].careerOther`}
                      control={control}
                    />
                  </Grid>
                )}
                <Grid item xs={2} sm={2}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        type="number"
                        variant="filled"
                        label="อัตราเงินเดือน (บาท)"
                        fullWidth
                        inputProps={{ min: 0 }}
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...field}
                        // onChange={(e) => {
                        //   // ให้ใส่ได้เฉพาะตัวเลข
                        //   const value = e.target.value.replace(/[^0-9]/g, '');
                        //   field.onChange(value ? parseInt(value) : '');
                        // }}
                      />
                    )}
                    name={`workExperience[${index}].workSalary`}
                    control={control}
                  />
                </Grid>
                <Grid item xs={2} sm={2}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={th}
                  >
                    <rhf.Controller
                      control={control}
                      name={`workExperience[${index}].startDate`}
                      render={({
                        field: { onChange, value = null },
                        fieldState: { error },
                      }) => (
                        <DatePicker
                          // views={['year']}
                          label="วันที่เริ่มงาน"
                          inputFormat="dd/MM/yyyy"
                          value={value}
                          onChange={onChange}
                          renderInput={(params) => (
                            <TextField
                              variant="filled"
                              fullWidth
                              {...params}
                              error={!!error}
                              helperText={error ? error.message : null}
                            />
                          )}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={2} sm={2}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={th}
                  >
                    <rhf.Controller
                      control={control}
                      name={`workExperience[${index}].endDate`}
                      render={({
                        field: { onChange, value = null },
                        fieldState: { error },
                      }) => (
                        <DatePicker
                          label="วันที่สิ้นสุดงาน"
                          inputFormat="dd/MM/yyyy"
                          value={value}
                          onChange={onChange}
                          renderInput={(params) => (
                            <TextField
                              variant="filled"
                              fullWidth
                              {...params}
                              error={!!error}
                              helperText={error ? error.message : null}
                            />
                          )}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={2} sm={2}>
                  <rhf.Controller
                    name={`workExperience[${index}].isUntilNow`}
                    control={rhf.control}
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            {...field}
                            checked={!!field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                            inputProps={{
                              'aria-label': `isUntilNow-${index}-label`,
                            }}
                          />
                        }
                        label="ถึงปัจจุบัน"
                      />
                    )}
                  />
                  {rhf.errors.workExperience?.[index]?.isUntilNow?.message && (
                    <span style={{ color: '#d32f2f' }}>
                      {rhf.errors.workExperience[index].isUntilNow.message}
                    </span>
                  )}
                </Grid>
                <Grid item xs={2} sm={2}>
                  <rhf.Controller
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        variant="filled"
                        label="เป็นระยะเวลา (ปี)"
                        fullWidth
                        type="number"
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...field}
                      />
                    )}
                    name={`workExperience[${index}].workPeriod`}
                    control={control}
                  />
                </Grid>
                {index != 0 && (
                  <Grid item xs={2} sm={2}>
                    <Button
                      variant="outlined"
                      startIcon={<DeleteOutlineIcon />}
                      onClick={() => {
                        workExperienceRemove(index);
                      }}
                    >
                      ลบ
                    </Button>
                  </Grid>
                )}

                <Grid item xs={12} sm={12}></Grid>
              </>
            );
          })}
        <Grid item xs={3} sm={3}>
          <Button
            variant="outlined"
            onClick={() => {
              hasWorkExperience == 'Y' && workExperienceAppend({});
              // hasWorkExperienceRdx == 'Y' && workExperienceAppend({});
            }}
          >
            + เพิ่มประสบการณ์ทำงาน
          </Button>
        </Grid>

        <Grid item xs={3} sm={3}></Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>
      {/* 
      |
      |
      | ประวัติการฝึกอบรม/ฝึกงาน
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ประวัติการฝึกอบรม/ฝึกงาน</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        {trainingHistoryFields.map((item, index) => {
          return (
            <>
              <Grid
                item
                xs={3}
                sm={3}
                component={Stack}
                justifyContent="flex-start"
                alignItems="flex-end"
              >
                <Typography
                  sx={{
                    pb: 0,
                    pt: 0,
                    color: 'success.main',
                  }}
                  variant="subtitle1"
                  gutterBottom
                >
                  {index != 0 && `หน่วยงานที่ ${index + 1}`}
                </Typography>
              </Grid>
              <Grid item xs={9} sm={9}></Grid>

              <Grid item xs={2} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
                  <rhf.Controller
                    control={control}
                    name={`trainingHistory[${index}].year`}
                    render={({
                      field: { onChange, value = null },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        views={['year']}
                        label="ปี พ.ศ."
                        // inputFormat="dd/MM/yyyy"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField
                            variant="filled"
                            fullWidth
                            {...params}
                            error={!!error}
                            helperText={error ? error.message : null}
                          />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3} sm={3}>
                <rhf.Controller
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="filled"
                      label="ชื่อหน่วยงาน"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      {...field}
                    />
                  )}
                  name={`trainingHistory[${index}].companyName`}
                  control={control}
                />
              </Grid>

              {index != 0 ? (
                <Grid item xs={2} sm={2}>
                  <Button
                    variant="outlined"
                    startIcon={<DeleteOutlineIcon />}
                    onClick={() => trainingHistoryRemove(index)}
                  >
                    ลบ
                  </Button>
                </Grid>
              ) : (
                <Grid item xs={2} sm={2}></Grid>
              )}
              <Grid item xs={5} sm={5}></Grid>

              <Grid item xs={12} sm={12}></Grid>
            </>
          );
        })}
        <Grid item xs={3} sm={3}>
          <Button
            variant="outlined"
            onClick={() => {
              trainingHistoryAppend({});
            }}
          >
            + เพิ่มประวัติการฝึกอบรม/ฝึกงาน
          </Button>
        </Grid>

        <Grid item xs={3} sm={3}></Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={4} sm={4}></Grid>
      </Grid>
      {/* 
      |
      |
      | ความรู้ด้านคอมพิวเตอร์
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ความรู้ด้านคอมพิวเตอร์</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Paper elevation={1}>
            <CheckboxFieldRHFRow
              name="computerSkills"
              label="computerSkills-label"
              rhf={rhf}
              options={computerSkillOptions}
              error={rhf.errors.computerSkills}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
      </Grid>
      {/* 
      |
      |
      | ความรู้ความสามารถพิเศษอื่นๆ (ถ้ามี)
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ความรู้ความสามารถพิเศษอื่นๆ (ถ้ามี)</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={6} sm={6}>
          <OthersSkill rhf={rhf} control={control} />
        </Grid>
        <Grid item xs={6} sm={6} />
      </Grid>
      {/* 
      |
      |
      | สถานะทางทหาร
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>สถานะทางทหาร</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={9} sm={9}>
          <Paper elevation={1}>
            <RadioFieldRHFRow
              name="militaryStatus"
              label="militaryStatus-label"
              rhf={rhf}
              options={militaryStatusOptions}
              error={rhf.errors.militaryStatus}
              // initial '' ที่ EmploymentPage ด้วย
            />
            <rhf.Controller
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ ml: 7, mb: 3, pr: 24 }}
                  variant="filled"
                  label="เหตุผล"
                  fullWidth
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              name="militaryStatusReason"
              control={control}
            />
          </Paper>
        </Grid>
        <Grid item xs={3} sm={3}></Grid>
      </Grid>
      {/* 
      |
      |
      | สถานภาพ
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>สถานภาพ</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        {/* <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            *ประวัติการทำงานกับบริษัทเอกชน หรือราชการอื่นๆรวมทั้งเหตุผลที่ออก
            เช่น เปลี่ยนงานใหม่ ย้ายสถานที่ทำงาน เป็นต้น
          </Typography>
        </Grid> */}
        <Grid item xs={12} sm={12}>
          <Paper elevation={1}>
            <RadioFieldRHFRow
              name="maritalStatus"
              label="maritalStatus-label"
              rhf={rhf}
              options={maritalStatusOptions}
              error={rhf.errors.maritalStatus}
              // initial '' ที่ EmploymentPage ด้วย
            />
          </Paper>
        </Grid>
        {hasMarried == 'Y' && (
          <>
            <Grid item xs={5} sm={5}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="ชื่อ-นามสกุล คู่สมรส"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="spouseName"
                control={control}
              />
            </Grid>
            <Grid item xs={2} sm={2}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="จำนวนบุตร"
                    fullWidth
                    error={!!error}
                    type="number"
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="numberOfChildren"
                control={control}
              />
            </Grid>
            <Grid item xs={5} sm={5}></Grid>
            <Grid item xs={5} sm={5}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="สถานที่ทำงานคู่สมรส"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="spouseOffice"
                control={control}
              />
            </Grid>
            <Grid item xs={2} sm={2}>
              <rhf.Controller
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="filled"
                    label="โทรศัพท์"
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : null}
                    {...field}
                  />
                )}
                name="spousePhone"
                control={control}
              />
            </Grid>
          </>
        )}
      </Grid>

      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>ข้อมูลแจ้งเพื่อทราบ</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ฝ่ายทรัพยากรบุคคลและพัฒนาองค์การ (อทบ.) ขอแจ้งให้ท่านทราบดังนี้
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            1. ผู้ปฏิบัติงานใหม่ที่รายงานตัวเข้าทำงานกับ กฟผ.
            จะมีสิทธิได้รับการพิจารณาขึ้นเงินเดือนในปีถัดไปเมื่อมีระยะเวลาในการปฏิบัติงานนับตั้งแต่เป็นลูกจ้างทดลองงานครบ
            6 เดือนขึ้นไป
            และจะมีสิทธิได้รับโบนัสประจำปีเมื่อมีระยะเวลาในการปฏิบัติงานนับตั้งแต่บรรจุเป็นพนักงานครบ
            6 เดือนขึ้นไป ทั้งนี้ เป็นไปตามระเบียบ กฟผ. ฉบับที่ 496 ว่าด้วย
            บุคคล หมวด 5 การขึ้นเงินเดือนค่าจ้างประจำปี และระเบียบ กฟผ. ฉบับที่
            310 ว่าด้วย โบนัส
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            2. ข้อมูลสวัสดิการของผู้ปฏิบัติงาน กฟผ. เป็นไปตามระเบียบ กฟผ.
            ฉบับที่ 496 ว่าด้วย บุคคล
            โดยท่านสามารถศึกษารายละเอียดเบื้องต้นได้จาก{' '}
            <a href="/app/document5.pdf" target="_blank">
              เอกสารรายการสวัสดิการและสิทธิประโยชน์ของผู้ปฏิบัติงาน กฟผ.
            </a>
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            3. ผู้ปฏิบัติงานใหม่ที่รายงานตัวเข้าทำงานกับ กฟผ.
            ต้องปฏิบัติงานในตำแหน่ง ลักษณะงาน
            และสถานที่ปฏิบัติงานที่เลือกสมัครเป็นเวลาไม่น้อยกว่า 5
            ปีนับตั้งแต่วันที่ได้รับการบรรจุ
            จึงจะสามารถยื่นความประสงค์ขอย้ายหน่วยงานได้ ทั้งนี้
            อยู่ในดุลยพินิจของผู้บังคับบัญชาหน่วยงาน และต้องดำเนินการตามระเบียบ
            หลักเกณฑ์ของ กฟผ.
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            4. กฟผ. ไม่มีนโยบายการปรับวุฒิให้แก่ผู้ปฏิบัติงานใหม่ ทั้งนี้
            ในกรณีที่ผู้ปฏิบัติงานไปศึกษาต่อในระดับคุณวุฒิที่สูงกว่าคุณวุฒิที่สมัครตามประกาศรับสมัครงาน
            สามารถนำหลักฐานด้านคุณวุฒิมายื่นต่อ กฟผ.
            เพื่อเพิ่มเติมข้อมูลคุณวุฒิการศึกษาลงในระบบประวัติบุคคลได้
          </Typography>
        </Grid>
      </Grid>

      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>คำขอมีบัตรลูกจ้างทดลองงาน</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {/* ข้าพเจ้าขอแจ้งความประสงค์ขอมีบัตรลูกจ้างทดลองงาน */}
            {/* โดยยินยอมให้ใช้รูปถ่ายจากระบบประวัติบุคคล กฟผ. */}
            ข้าพเจ้าขอแจ้งความประสงค์มีบัตรประจำตัวลูกจ้างทดลองงาน
            เพื่อให้เป็นไปตามระเบียบ กฟผ. ฉบับที่ 482 ว่าด้วย บัตรประจำตัว
            และระเบียบ กฟผ. ฉบับที่ 509 ว่าด้วยบัตรประจำตัว
            (แก้ไขเพิ่มเติมครั้งที่ 1)
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={8} sm={8}></Grid>
        <Grid item xs={3} sm={3} />
      </Grid>

      {/* 
      |
      |
      | คำรับรองผู้สมัคร
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 2 }}>
        <H3>คำรับรองผู้สมัครและนโยบายคุ้มครองข้อมูลส่วนบุคคล</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ข้าพเจ้าขอให้คำรับรองว่าเป็นผู้มีคุณสมบัติตรงตามประกาศ กฟผ.
            และไม่มีลักษณะต้องห้ามดังกล่าวข้างต้น
            รวมทั้งข้อความและเอกสารหลักฐานตามที่ระบุไว้ในใบสมัครนี้เป็นความจริง
            ถูกต้อง สมบูรณ์ทุกประการ ข้าพเจ้ายินยอมให้ กฟผ.
            ตรวจสอบความถูกต้องของข้อมูลและเอกสารหลักฐาน รวมถึงยินยอมให้นายจ้าง
            สถาบัน หรือบุคคลใดๆ ให้รายละเอียดดังกล่าวแก่ กฟผ. ทั้งนี้ กฟผ.
            สงวนสิทธิ์ในการตรวจสอบความถูกต้องของข้อมูลและเอกสารต่างๆ
            ย้อนหลังได้ทุกกรณี และหาก กฟผ. ตรวจสอบภายหลังแล้วพบว่า
            ข้าพเจ้าเป็นผู้ที่ไม่มีคุณสมบัติตามที่ กฟผ. กำหนด หรือข้อมูล
            เอกสารหลักฐานประกอบการจ้างไม่เป็นความจริง ไม่ถูกต้อง ไม่สมบูรณ์
            หรือใช้เอกสารปลอม จะถือว่าข้าพเจ้าเป็นผู้ขาดคุณสมบัติ และ กฟผ.
            มีสิทธิ์เลิกจ้าง รวมทั้งดำเนินคดีตามกฎหมาย
            โดยข้าพเจ้าไม่สามารถเรียกร้องสิทธิ์หรือค่าเสียหายใดๆ จาก กฟผ. ได้
          </Typography>
        </Grid>

        <Grid item xs={2} sm={2} />
        <Grid item xs={2} sm={2} />

        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            ลายเซ็น (Signature)
          </Typography>
        </Grid>

        <Grid item xs={6} sm={6}>
          <SignLayout
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            formikName={`file19Name`}
          />
        </Grid>

        {/* <Grid item xs={4} sm={4}>
          <UploadSignature
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            formikName={`file19Name`}
          />
        </Grid>
        <Grid item xs={4} sm={4} />
        <Grid item xs={2} sm={2} />
        <Grid item xs={2} sm={2} />
        <Grid item xs={4} sm={4}>
          <Button
            variant="outlined"
            component="span"
            onClick={()=> setSignPad(true)}
          >
            ลายเซ็นบนเว็บ
          </Button>
        </Grid>
        {signPad &&
          <>
            <Grid item xs={4} sm={4} />
            <Grid item xs={4} sm={4}>
              <SignPad />
            </Grid>
          </>
        } */}

        <Grid item xs={1} sm={1} />
        <Grid item xs={8} sm={8}>
          {/* <Paper elevation={1} sx={{ p: 4 }}> */}
          {/* <CheckboxFieldRHFRow
            name="acceptAgreement"
            label="acceptAgreement-label"
            rhf={rhf}
            options={acceptAgreementOptions}
            error={rhf.errors.acceptAgreement}
            // initial '' ที่ EmploymentPage ด้วย
          /> */}
          {/* </Paper> */}
        </Grid>
        <Grid item xs={3} sm={3} />
      </Grid>

      <Box p={0} display="flex" sx={{ pb: 0, pt: 2 }}>
        <H3>นโยบายคุ้มครองข้อมูลส่วนบุคคล</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            <a href="/app/document6.pdf" target="_blank">
              กรุณาอ่าน นโยบายคุ้มครองข้อมูลส่วนบุคคลของผู้สมัคร
            </a>
          </Typography>
          {/* <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            <a
              href="https://ecp.egat.co.th/index.php/s/UwXqk32VI2log8f"
              target="_blank"
            >
              กรุณาอ่าน นโยบายคุ้มครองข้อมูลส่วนบุคคลของผู้สมัคร
            </a>
          </Typography> */}
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <CheckboxFieldRHFRow
            name="acceptAgreement"
            label="acceptAgreement-label"
            rhf={rhf}
            options={acceptAgreementOptions}
            error={rhf.errors.acceptAgreement}
            // initial '' ที่ EmploymentPage ด้วย
          />
        </Grid>
      </Grid>

      <Box p={0} display="flex" sx={{ pb: 0, pt: 2 }}>
        <H3>เอกสารการให้ความยินยอมสำหรับผู้สมัครงาน</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            เพื่อปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
            การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย <b>(“กฟผ.”) </b>
            ใคร่ขอความยินยอมจากท่านในฐานะเจ้าของข้อมูลส่วนบุคคลในการประมวลผลข้อมูลส่วนบุคคลของท่าน
            สำหรับวัตถุประสงค์ดังต่อไปนี้
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            เพื่อให้ กฟผ. เก็บรวบรวม ใช้ และเปิดเผย
            ข้อมูลศาสนาและ/หรือหมู่โลหิตที่ปรากฏบนสำเนาบัตร
            ประจำตัวประชาชนและเอกสารอื่น เชื้อชาติ ประวัติอาชญากรรม ลายนิ้วมือ
            (กรณีเป็นข้อมูลชีวภาพ) ผลการ ตรวจสารเสพติด ผลการตรวจร่างกาย
            ข้อมูลสุขภาพ และความพิการหรือสภาพเฉพาะของข้าพเจ้า
            ให้แก่หน่วยงานที่เกี่ยวข้อง เช่น กองทุนเงินให้กู้ยืมเพื่อการศึกษา
            สำนักงานสัสดีประจำจังหวัด หน่วยบัญชาการรักษาดินแดน
            สำนักงานคณะกรรมการการอาชีวศึกษา สถาบันการศึกษา สถาบันหรือ
            ศูนย์ทดสอบภาษาอังกฤษ สถาบันจัดทดสอบให้ กฟผ. โรงพยาบาล
            สถานพยาบาลทั้งภาครัฐและเอกชน นายจ้างเดิมของข้าพเจ้า เป็นต้น
            เพื่อการพิจารณาและการคัดเลือกผู้สมัครงานหรือผู้สมัครฝึกงาน รวมถึง
            การดำเนินการอื่น ๆ ที่เกี่ยวข้อง เช่น การ
            ตรวจสอบประวัติและคุณสมบัติของข้าพเจ้า การทดสอบ การสัมภาษณ์
            การประเมินผลการสัมภาษณ์ การ รายงานตัว การตรวจสุขภาพ
            การทำสัญญาที่เกี่ยวข้อง เป็นต้น
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            อนึ่ง กฟผ.
            ขอแจ้งให้ท่านทราบเกี่ยวกับการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านตาม{' '}
            <a
              href="https://www.egat.co.th/privacy-notice-hr.html"
              target="_blank"
            >
              <b>
                <u>
                  ประกาศ ความเป็นส่วนตัว (Privacy Notice)
                  สำหรับการบริหารงานบุคคล รวมถึงคณะกรรมการ ผู้ปฏิบัติงาน
                  และบุคคลอื่นที่เกี่ยวข้อง
                </u>
              </b>
            </a>
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ทั้งนี้ พ.ร.บ. คุณสมบัติมาตรฐานสำหรับกรรมการและพนักงานรัฐวิสาหกิจ
            พ.ศ. 2518 มาตรา 9 และข้อบังคับการไฟฟ้าฝ่ายผลิตแห่งประเทศไทย ว่าด้วย
            บุคคล หมวด 1 การจ้าง การบรรจุ การแต่งตั้ง การเลื่อนระดับ และการย้าย
            ข้อ 9 ผู้ที่จะได้รับการจ้าง การบรรจุ
            ต้องเป็นผู้มีคุณสมบัติและไม่มีลักษณะต้องห้าม
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ดังนั้น <u>โปรดทราบว่า</u>{' '}
            หากท่านไม่ให้ความยินยอมหรือถอนความยินยอมในภายหลังสำหรับวัตถุประสงค์ดังกล่าวข้างต้น
            กฟผ. อาจไม่สามารถบริหารหรือจัดการสัญญาหรืออำนวยความสะดวก
            แก่เจ้าของข้อมูลส่วนบุคคลได้ และ กฟผ.
            อาจมีความจำเป็นต้องเก็บรวบรวมข้อมูลส่วนบุคคลดังกล่าว
            เพื่อใช้ในการตรวจสอบภายหลัง หาก กฟผ. ตรวจพบในภายหลังว่า
            ข้อมูลส่วนบุคคลดังกล่าวไม่เป็นไปตามข้อบังคับที่กำหนด กฟผ.
            มีสิทธิบอกเลิกการจ้างโดยไม่ต้องจ่ายค่าเสียหายใด ๆ ทั้งสิ้น
            และหักเงินที่ท่านมีสิทธิได้รับ ชดใช้หนี้สินแก่ กฟผ. จนหมด
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            อย่างไรก็ตาม
            การถอนความยินยอมดังกล่าวไม่มีผลกระทบต่อการประมวลผลข้อมูลส่วนบุคคลที่ได้ดำเนินการเสร็จสิ้นไปแล้วก่อนการถอนความยินยอม
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ข้าพเจ้าได้อ่านและเข้าใจวัตถุประสงค์เกี่ยวกับการประมวลผลข้อมูลส่วนบุคคล
            และประกาศ ความเป็นส่วนตัว (Privacy Notice) ของ กฟผ. แล้ว ดังนั้น
            ข้าพเจ้าขอแสดงความประสงค์ให้ กฟผ.
            ประมวลผลข้อมูลส่วนบุคคลของข้าพเจ้าสำหรับข้อมูลส่วนบุคคลที่มีความอ่อนไหวเพื่อวัตถุประสงค์ดังกล่าวข้างต้น
          </Typography>
        </Grid>
        <Grid item xs={9} sm={9}></Grid>
        <Grid item xs={2} sm={2} />
        <Grid item xs={1} sm={1} />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <RadioGroup
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
                row
                aria-label="acceptConsent-label"
                name="acceptConsent"
                defaultValue="top"
              >
                {acceptConsentOptions.map((option) => (
                  <FormControlLabel
                    value={option.id}
                    control={<Radio color="primary" />}
                    label={option.name}
                  />
                ))}
                {/* <FormControlLabel
                  value="end"
                  control={<Radio color="primary" />}
                  label="End"
                /> */}
              </RadioGroup>

              // <TextField
              //   variant="filled"
              //   label="จำนวนบุตร"
              //   fullWidth
              //   error={!!error}
              //   type="number"
              //   helperText={error ? error.message : null}
              //   {...field}
              // />
            )}
            name="acceptConsent"
            control={control}
          />
          {/* <CheckboxFieldRHFRow
            name="acceptConsent"
            label="acceptConsent-label"
            rhf={rhf}
            options={acceptConsenttOptions}
            error={rhf.errors.acceptConsent}
            // initial '' ที่ EmploymentPage ด้วย
          /> */}
        </Grid>

        <Grid item xs={1} sm={1} />
        <Grid item xs={9} sm={9}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ทั้งนี้ หากประสงค์จะเพิกถอนความยินยอมที่ให้ไว้นี้ สามารถแจ้ง กฟผ.
            ได้ที่ <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b> เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล</b> <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            สถานที่ติดต่อ
            :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;53
            หมู่ 2 ถนนจรัญสนิทวงศ์ ตำบลบางกรวย อำเภอบางกรวย จังหวัดนนทบุรี 11130{' '}
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            หมายเลขโทรศัพท์
            :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1416{' '}
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            จดหมายอิเล็กทรอนิกส์ :&nbsp;&nbsp;&nbsp;&nbsp;cmcegat@egat.co.th
          </Typography>
        </Grid>
      </Grid>

      {/* 
      |
      |
      | เอกสารแนบ
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>เอกสารแนบประกอบการทำหลักฐาน</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            แนบเอกสารตามหัวข้อที่ระบุ และรับรองสำเนาถูกต้องทุกฉบับ
          </Typography>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำหรับผู้ที่แนบ สด.8 ขอให้แนบทั้ง 2 หน้า
          </Typography>
          {/* <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            ผู้สมัครยังไม่ต้องยื่นใบผ่านงาน/ใบลาออก จนกว่า HR
            จะยืนยันวันเข้าทำงานที่ กฟผ.
          </Typography> */}
        </Grid>
        {/* <Grid item xs={12} sm={12}> */}
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาคุณวุฒิ (Transcript)
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาคุณวุฒิ`}
            formikName={`file4Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            ใบปริญญาบัตร
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` ใบปริญญาบัตร`}
            formikName={`file5Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาทะเบียนบ้านตนเอง
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาทะเบียนบ้านตนเอง`}
            formikName={`file6Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาบัตรประชาชนตนเอง
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาบัตรประชาชนตนเอง`}
            formikName={`file7Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาทะเบียนบ้านบิดา
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาทะเบียนบ้านบิดา`}
            formikName={`file8Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาบัตรประชาชนบิดา
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาบัตรประชาชนบิดา`}
            formikName={`file9Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>

        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาทะเบียนบ้านมารดา
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาทะเบียนบ้านมารดา`}
            formikName={`file10Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาบัตรประชาชนมารดา
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาบัตรประชาชนมารดา`}
            formikName={`file11Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>

        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาสด.8/สด.43
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาสด.8/สด.43`}
            formikName={`file12Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาใบเปลี่ยนชื่อ/นามสกุล ตนเอง
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาใบเปลี่ยนชื่อ/นามสกุล ตนเอง`}
            formikName={`file13Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>

        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาทะเบียนบ้านคู่สมรส
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` ทะเบียนบ้านที่มีชื่อคู่สมรส บุตร`}
            formikName={`file14Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาใบสำคัญทะเบียนสมรส
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาใบสำคัญทะเบียนสมรส`}
            formikName={`file15Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            ทะเบียนบ้านบุตรที่มีชื่อคู่สมรส บุตร
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            // msg1={` สำเนาสูติบัตรบุตร`}
            formikName={`file3Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาสูติบัตรบุตร
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาสูติบัตรบุตร`}
            formikName={`file16Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={6} sm={6}></Grid>
        {/* <Grid item xs={2} sm={2} >
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนารับรองการผ่านงาน และใบลาออก
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            formikName={`file17Name`}
          />
        </Grid> */}
        <Grid item xs={8} sm={8}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนาเอกสารคุณสมบัติเฉพาะตำแหน่งงาน เช่น ใบกว. เนติบัณฑิต
            วุฒิบัตรผู้สอบบัญชี CIA CISA เป็นต้น
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          {/* {JSON.stringify(formikProps.file1Name)} */}
          {/* <FileUpload /> */}
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาเอกสารคุณสมบัติเฉพาะตำแหน่งงาน`}
            formikName={`file18Name`}
            // rdxFileData={file1Data}
            // rdxSetFileData={setFile1Data}
          />
        </Grid>
        <Grid item xs={8} sm={8}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            สำเนารับรองการผ่านงาน และใบลาออก{' '}
            <span style={{ color: 'red' }}>
              (ผู้สมัครยังไม่ต้องยื่นใบผ่านงาน/ใบลาออก จนกว่า HR
              จะยืนยันวันเข้าทำงานที่ กฟผ.)
            </span>
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          <FileUpload
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            formikName={`file17Name`}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          {' '}
          <Button
            variant="outlined"
            color="primary"
            onClick={() => uploadPW(idCardWatch)}
            // onClick={() => uploadPW('1529900917492')}
            disabled={isUploadingPW}
            startIcon={isUploadingPW ? <CircularProgress size={20} /> : null}
          >
            {isUploadingPW ? 'กำลังอัพโหลด...' : 'อัพโหลดเอกสารทั้งหมดเข้า PW'}
          </Button>
        </Grid>
        {/* <Grid item xs={8} sm={8}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            pw
          </Typography>
        </Grid>
        <Grid item xs={4} sm={4}>
          <DialogCheckboxDelayedSubmit
            {...props}
            rhf={rhf}
            control={control}
            uid={idCardWatch}
            // msg1={` สำเนาเอกสารคุณสมบัติเฉพาะตำแหน่งงาน`}
            formikName={`file4Name`}
          />
        </Grid>

        {/* <Grid item xs={1} sm={1}></Grid> */}
        {/* </Paper> */}
        {/* </Grid> */}
      </Grid>

      {/* 
      |
      |
      | HR กรอกเพิ่มเติม
      |
      |
      */}
      <Box p={0} display="flex" sx={{ pb: 0, pt: 7 }}>
        <H3>HR กรอกเพิ่มเติม</H3>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid item xs={12} sm={12}>
        <Typography sx={{ pb: 0, pt: 1 }} variant="subtitle1" gutterBottom>
          ออกเลขประจำตัวพนักงาน
        </Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={3} sm={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
            <rhf.Controller
              control={control}
              name={`empNo`}
              render={({ field }) => (
                <TextField
                  variant="filled"
                  label="รหัสประจำตัวพนักงาน"
                  fullWidth
                  {...field}
                  disabled
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={9} sm={9} />
        <Grid item xs={3} sm={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
            <rhf.Controller
              control={control}
              name={`startWorkDate`}
              render={({
                field: { onChange, value = null },
                fieldState: { error },
              }) => (
                <DatePicker
                  // views={['year']}
                  label="วันที่เริ่มงาน"
                  inputFormat="dd/MM/yyyy"
                  value={value}
                  onChange={onChange}
                  renderInput={(params) => (
                    <TextField
                      variant="filled"
                      fullWidth
                      {...params}
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={3} sm={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
            <rhf.Controller
              control={control}
              name={`endWorkDate`}
              render={({
                field: { onChange, value = null },
                fieldState: { error },
              }) => (
                <DatePicker
                  // views={['year']}
                  label="ถึงวันที่"
                  inputFormat="dd/MM/yyyy"
                  value={value}
                  onChange={onChange}
                  renderInput={(params) => (
                    <TextField
                      variant="filled"
                      fullWidth
                      {...params}
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={3} sm={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
            <rhf.Controller
              control={control}
              name={`signDate`}
              render={({
                field: { onChange, value = null },
                fieldState: { error },
              }) => (
                <DatePicker
                  // views={['year']}
                  label="วันที่ทำหลักฐาน"
                  inputFormat="dd/MM/yyyy"
                  value={value}
                  onChange={onChange}
                  renderInput={(params) => (
                    <TextField
                      variant="filled"
                      fullWidth
                      {...params}
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={3} sm={3}>
          {' '}
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ตำแหน่ง"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name={`position`}
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <Organization rhf={rhf} control={control} name={`empDivision`} />
        </Grid>
        <Grid item xs={3} sm={3}></Grid>
        {/* สถานที่ทำงาน */}
        {/* <Grid item xs={3} sm={3}>
          <WorkLocation rhf={rhf} control={control} name={`workLocation`} />
        </Grid> */}
        <Grid item xs={3} sm={3}>
          {/* <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="รหัสสังกัด"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name={`orgCode`}
            control={control}
          /> */}
        </Grid>

        <Grid item xs={3} sm={3}>
          <FormControl error={rhf.errors.psArea} variant="filled" fullWidth>
            <InputLabel>กลุ่มคุณวุฒิ (PS Area)</InputLabel>
            <Controller
              render={({ field: { onChange, value } }) => (
                <Select onChange={onChange} value={value} defaultValue="">
                  {psAreaOptions.map((el) => (
                    <MenuItem key={el.value} value={el.value}>
                      {el.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              control={control}
              name={`psArea`}
            />
            <FormHelperText error={rhf.errors.psArea}>
              {rhf.errors.psArea ? rhf.errors.psArea.message : ''}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={3} sm={3}>
          <FormControl error={rhf.errors.psGroup} variant="filled" fullWidth>
            <InputLabel>ระดับ (PS Group)</InputLabel>
            <Controller
              render={({ field: { onChange, value } }) => (
                <Select onChange={onChange} value={value} defaultValue="">
                  {psGroupOptions?.map((el) => (
                    <MenuItem key={el.value} value={el.value}>
                      {el.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              control={control}
              name={`psGroup`}
            />
            <FormHelperText error={rhf.errors.psGroup}>
              {rhf.errors.psGroup ? rhf.errors.psGroup.message : ''}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="อัตราค่าจ้างแรกเข้า"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
                disabled
                InputLabelProps={{
                  shrink:
                    field.value !== undefined &&
                    field.value !== null &&
                    field.value !== '',
                }}
              />
            )}
            name={`baseSalary`}
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}></Grid>
        <Grid item xs={3} sm={3}>
          <Controller
            name={`isHonorGraduate`}
            control={control}
            render={({ field }) =>
              [{ id: 1, name: 'เกียรตินิยม' }].map((singleOption) => (
                <FormControlLabel
                  key={singleOption.id}
                  label={singleOption.name}
                  disabled
                  control={
                    <Checkbox
                      onChange={(event, checked) => {
                        field.onChange(checked ? singleOption.id : null);
                      }}
                      checked={field.value == singleOption.id}
                    />
                  }
                />
              ))
            }
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ค่าเกียรตินิยม"
                disabled={!watchIsHonorGraduate}
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
                InputLabelProps={{
                  shrink:
                    field.value !== undefined &&
                    field.value !== null &&
                    field.value !== '',
                }}
              />
            )}
            name={`honorRate`}
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="รวม"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
                InputLabelProps={{
                  shrink:
                    field.value !== undefined &&
                    field.value !== null &&
                    field.value !== '',
                }}
              />
            )}
            name={`salary`}
            control={control}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12}>
        <Typography sx={{ pb: 0, pt: 1 }} variant="subtitle1" gutterBottom>
          กจ.2
        </Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                disabled
                variant="filled"
                label="สังกัดแผนก"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name={`empSection`}
            control={control}
          />
        </Grid>

        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                disabled
                variant="filled"
                label="กอง"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name={`empDepartment`}
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                disabled
                variant="filled"
                label="รหัสสังกัด"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name={`orgCode`}
            control={control}
          />
        </Grid>

        <Grid item xs={6} sm={6}>
          {/* การใช้อัตรา */}
          <EmploymentRate
            rhf={rhf}
            control={control}
            name={`employmentRateId`}
          />
        </Grid>
        <Grid item xs={6} sm={6}></Grid>

        {/* หัวหน้าแผนก HR */}
        <Grid item xs={3} sm={3}>
          <HrSupervisor rhf={rhf} control={control} name={`hrHead`} role={2} />
        </Grid>
        <Grid item xs={9} sm={9}></Grid>
        {hrHeadWatch?.empNo && (
          <>
            <Grid item xs={2} sm={2}>
              <Typography
                sx={{ pb: 0, pt: 0 }}
                variant="subtitle1"
                gutterBottom
              >
                ลายเซ็น (Signature)
              </Typography>
            </Grid>

            <Grid item xs={6} sm={6}>
              <SignLayout
                {...props}
                rhf={rhf}
                control={control}
                uid={hrHeadWatch?.empNo}
                formikName={`file20Name`}
              />
            </Grid>
            <Grid item xs={3} sm={3}></Grid>
          </>
        )}

        {/* หัวหน้ากองสรรหาและงานบุคคล */}
        {/* <Grid item xs={3} sm={3}>
          <HrSupervisor rhf={rhf} control={control} name={`hrChief`} role={1} />
        </Grid>
        <Grid item xs={9} sm={9}></Grid> */}
        <Grid item xs={2} sm={2}>
          <Typography sx={{ pb: 0, pt: 0 }} variant="subtitle1" gutterBottom>
            ลายเซ็นหัวหน้ากองสรรหาและงานบุคคล (Signature)
          </Typography>
        </Grid>
        <Grid item xs={6} sm={6}>
          <SignLayout
            {...props}
            rhf={rhf}
            control={control}
            uid={hrChief?.empNo}
            formikName={`file21Name`}
          />
        </Grid>
        <Grid item xs={4} sm={4}></Grid>
        <Grid item xs={12} sm={12}></Grid>
        <Grid item xs={3} sm={3}>
          <rhf.Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="หมายเลขประจำตัวรองผู้ว่าการ ผู้เซ็นอนุมัติ"
                onChange={handleDeputyChange}
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name={`deputyNo`}
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={3}>
          <Controller
            name={`isActAsDeputy`}
            control={control}
            render={({ field }) =>
              isActAsDeputyOptions?.map((singleOption) => (
                <FormControlLabel
                  key={singleOption.id}
                  label={singleOption.name}
                  control={
                    <Checkbox
                      onChange={(event, checked) => {
                        field.onChange(checked ? singleOption.id : null);
                      }}
                      checked={field.value == singleOption.id}
                    />
                  }
                />
              ))
            }
          />
        </Grid>
      </Grid>
      {/* ทดสอบ redux */}
      {/* {file1Data?.name} */}
      {/* {cnt}
      <Button
        variant="outlined"
        color="primary"
        onClick={() => dispatch(increment())}
      >
        Primary
      </Button> */}

      {/* Upload Result Dialog */}
      <UploadResultDialog
        open={uploadResultDialog.open}
        onClose={closeUploadResultDialog}
        header={uploadResultDialog.header}
        results={uploadResultDialog.results}
        onViewFile={viewPWFileByDocId}
      />
    </React.Fragment>
  );
}
